import { defineComponent as L, computed as P, resolveComponent as K, openBlock as u, createElementBlock as b, normalizeClass as C, createElementVNode as v, createVNode as T, renderSlot as j, createTextVNode as le, toDisplayString as I, withDirectives as V, unref as w, vShow as Y, watch as Z, h as vt, useCssVars as te, createCommentVNode as A, createBlock as M, ref as S, Transition as Qe, withCtx as Me, Fragment as ye, renderList as _e, isRef as mi, vModelText as Ze, resolveDynamicComponent as hi, pushScopeId as gt, popScopeId as bt, Teleport as Aa, getCurrentScope as vi, onScopeDispose as gi, reactive as bi, onMounted as pi } from "vue";
var ke = /* @__PURE__ */ ((e) => (e.WARNING = "warning", e.ERROR = "severe", e.SUCCESS = "mild", e.INFO = "none", e))(ke || {}), Ce = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.LINK = "link", e.LINKALT = "linkalt", e.TERTIARY = "tertiary", e))(Ce || {}), re = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e))(re || {}), R = /* @__PURE__ */ ((e) => (e.AngleDown = "angle-down", e.AngleLeft = "angle-left", e.AngleRight = "angle-right", e.AngleUp = "angle-up", e.ArrowDown = "arrow-down", e.ArrowLeft = "arrow-left", e.ArrowsV = "arrows-v", e.Bookmark = "fa-regular fa-bookmark", e.CaretDown = "caret-down", e.CaretLeft = "caret-left", e.CaretRight = "caret-right", e.CaretUp = "caret-up", e.ChartColumn = "chart-column", e.Check = "check", e.Circle = "circle", e.CircleCheck = "circle-check", e.CircleCheckRegular = "fa-regular fa-circle-check", e.CircleExclamation = "circle-exclamation", e.CircleInfo = "circle-info", e.CircleInfoRegular = "fa-regular fa-circle-info", e.CircleXmarkRegular = "fa-regular fa-circle-xmark", e.Close = "close", e.Copy = "copy", e.Download = "download", e.ExternalLink = "external-link", e.EllipsisVertical = "ellipsis-vertical", e.File = "file", e.Gear = "gear", e.Link = "link", e.ListCheck = "list-check", e.Lock = "lock", e.LockOpen = "lock-open", e.MagnifyingGlass = "magnifying-glass", e.OutdentRegular = "fa-regular fa-outdent", e.Pencil = "pencil", e.Pen = "pen", e.PenRegular = "fa-regular fa-pen", e.PersonRunning = "person-running", e.Plus = "plus", e.Refresh = "refresh", e.RotateLeft = "rotate-left", e.RotateRight = "rotate-right", e.Spinner = "spinner", e.SpinnerThird = "spinner-third", e.Square = "square", e.Table = "table", e.TableColumnsRegular = "fa-regular fa-table-columns", e.TableListRegular = "fa-regular fa-table-list", e.Times = "times", e.Trash = "trash", e.TrashCan = "fa-regular fa-trash-can", e.TriangleExclamation = "triangle-exclamation", e.TriangleExclamationRegular = "fa-regular fa-triangle-exclamation", e.Users = "fa-users", e.Calendar = "fa-regular fa-calendar", e))(R || {}), H = /* @__PURE__ */ ((e) => (e.GOLD = "--alc-gold", e.FIRE = "--alc-fire", e.AQUA = "--alc-aqua", e.SKY = "--alc-sky", e.NIGHT = "--alc-night", e.BASE = "--alc-base", e.LIGHTGRAY = "--alc-lightGray", e.MEDIUMGRAY = "--alc-mediumGray", e.BLACK = "--alc-black", e.WHITE = "--alc-white", e.WARNINGLIGHT = "--alc-gold-100", e.ERRORLIGHT = "--alc-fire-100", e.SUCCESSLIGHT = "--alc-green-100", e.INFOLIGHT = "--alc-aqua-100", e.WARNING = "--alc-gold-500", e.ERROR = "--alc-fire-300", e.SUCCESS = "--alc-green-300", e.INFO = "--alc-aqua-300", e.NONE = "--alc-transparent", e.INHERIT = "--alc-inherit", e))(H || {}), ce = /* @__PURE__ */ ((e) => (e.SQUARE = "square", e.ROUND = "round", e))(ce || {}), He = /* @__PURE__ */ ((e) => (e.XSMALL = "12", e.SMALL = "16", e.MEDIUM = "20", e.LARGE = "24", e.XLARGE = "32", e.XXLARGE = "48", e))(He || {}), pt = /* @__PURE__ */ ((e) => (e.MOBILE = "mobile", e.SURVEY = "survey", e.WEB = "web", e.WORKFLOW = "workflow", e.CLONE = "clone", e.GRIPLARGE = "griplarge", e.GRIPSMALL = "gripsmall", e.STAR = "star", e))(pt || {}), yi = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XLARGE = "xlarge", e))(yi || {});
const _i = { class: "alc-alert__text" }, ki = /* @__PURE__ */ L({
  __name: "AlcAlert",
  props: {
    alertType: { default: ke.WARNING },
    alertIcon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    message: { default: void 0 }
  },
  emits: ["on-close-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = P(() => t.alertType === ke.INFO ? R.CircleInfoRegular : t.alertType === ke.WARNING ? R.TriangleExclamationRegular : t.alertType === ke.ERROR ? R.CircleXmarkRegular : t.alertType === ke.SUCCESS ? R.CircleCheckRegular : R.TriangleExclamationRegular);
    return (i, o) => {
      const l = K("FontAwesomeIcon");
      return u(), b("div", {
        class: C(["alc-alert", `alc-alert--${i.alertType}`])
      }, [
        v("div", null, [
          T(l, {
            icon: r.value,
            class: C(["alc-alert__icon", `alc-alert__icon--${i.alertType}`])
          }, null, 8, ["icon", "class"])
        ]),
        v("div", _i, [
          j(i.$slots, "default", {}, () => [
            le(I(i.message), 1)
          ], !0)
        ]),
        V(v("div", null, [
          T(l, {
            icon: w(R).Close,
            class: C(["alc-alert__icon alc-alert__icon--clickable", `alc-alert__icon--${i.alertType}`]),
            title: "close",
            onClick: o[0] || (o[0] = (c) => n("on-close-click"))
          }, null, 8, ["icon", "class"])
        ], 512), [
          [Y, i.closable]
        ])
      ], 2);
    };
  }
}), $ = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [n, r] of a)
    t[n] = r;
  return t;
}, wi = /* @__PURE__ */ $(ki, [["__scopeId", "data-v-b8c0086e"]]), ja = () => {
};
let Na = {}, yt = {}, _t = null, kt = {
  mark: ja,
  measure: ja
};
try {
  typeof window < "u" && (Na = window), typeof document < "u" && (yt = document), typeof MutationObserver < "u" && (_t = MutationObserver), typeof performance < "u" && (kt = performance);
} catch {
}
const {
  userAgent: Fa = ""
} = Na.navigator || {}, se = Na, O = yt, Ua = _t, Fe = kt;
se.document;
const ne = !!O.documentElement && !!O.head && typeof O.addEventListener == "function" && typeof O.createElement == "function", wt = ~Fa.indexOf("MSIE") || ~Fa.indexOf("Trident/");
var z = "classic", Pt = "duotone", F = "sharp", U = "sharp-duotone", Pi = [z, Pt, F, U], Ci = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds"
  }
}, Ga = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, Ai = ["kit"], Ni = /fa(s|r|l|t|d|b|k|kd|ss|sr|sl|st|sds)?[\-\ ]/, Mi = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, Li = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
}, Oi = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds"
  }
}, Si = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds"
  }
}, zi = {
  classic: ["fas", "far", "fal", "fat"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds"]
}, Di = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid"
  }
}, Ti = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds"
  }
}, Ct = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fad: "duotone",
    "fa-duotone": "duotone",
    fab: "brands",
    "fa-brands": "brands"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid"
  }
}, Ii = ["solid", "regular", "light", "thin", "duotone", "brands"], At = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Ri = At.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Se = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Hi = [...Object.keys(zi), ...Ii, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Se.GROUP, Se.SWAP_OPACITY, Se.PRIMARY, Se.SECONDARY].concat(At.map((e) => "".concat(e, "x"))).concat(Ri.map((e) => "w-".concat(e))), $i = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, Ei = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
}, Vi = {
  kit: {
    fak: "fa-kit"
  },
  "kit-duotone": {
    fakd: "fa-kit-duotone"
  }
}, Wa = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
};
const ee = "___FONT_AWESOME___", ca = 16, Nt = "fa", Mt = "svg-inline--fa", be = "data-fa-i2svg", sa = "data-fa-pseudo-element", Bi = "data-fa-pseudo-element-pending", Ma = "data-prefix", La = "data-icon", Ya = "fontawesome-i2svg", ji = "async", Fi = ["HTML", "HEAD", "STYLE", "SCRIPT"], Lt = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})(), Ot = [z, F, U];
function Ve(e) {
  return new Proxy(e, {
    get(a, t) {
      return t in a ? a[t] : a[z];
    }
  });
}
const St = {
  ...Ct
};
St[z] = {
  ...Ct[z],
  ...Ga.kit,
  ...Ga["kit-duotone"]
};
const ve = Ve(St), fa = {
  ...Ti
};
fa[z] = {
  ...fa[z],
  ...Wa.kit,
  ...Wa["kit-duotone"]
};
const $e = Ve(fa), ua = {
  ...Di
};
ua[z] = {
  ...ua[z],
  ...Vi.kit
};
const ge = Ve(ua), da = {
  ...Si
};
da[z] = {
  ...da[z],
  ...Ei.kit
};
const Ui = Ve(da), Gi = Ni, zt = "fa-layers-text", Wi = Mi, Yi = {
  ...Ci
};
Ve(Yi);
const Xi = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], ta = Se, Ae = /* @__PURE__ */ new Set();
Object.keys($e[z]).map(Ae.add.bind(Ae));
Object.keys($e[F]).map(Ae.add.bind(Ae));
Object.keys($e[U]).map(Ae.add.bind(Ae));
const Ki = [...Ai, ...Hi], Te = se.FontAwesomeConfig || {};
function qi(e) {
  var a = O.querySelector("script[" + e + "]");
  if (a)
    return a.getAttribute(e);
}
function Qi(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
O && typeof O.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((a) => {
  let [t, n] = a;
  const r = Qi(qi(t));
  r != null && (Te[n] = r);
});
const Dt = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: Nt,
  replacementClass: Mt,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Te.familyPrefix && (Te.cssPrefix = Te.familyPrefix);
const Ne = {
  ...Dt,
  ...Te
};
Ne.autoReplaceSvg || (Ne.observeMutations = !1);
const g = {};
Object.keys(Dt).forEach((e) => {
  Object.defineProperty(g, e, {
    enumerable: !0,
    set: function(a) {
      Ne[e] = a, Ie.forEach((t) => t(g));
    },
    get: function() {
      return Ne[e];
    }
  });
});
Object.defineProperty(g, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Ne.cssPrefix = e, Ie.forEach((a) => a(g));
  },
  get: function() {
    return Ne.cssPrefix;
  }
});
se.FontAwesomeConfig = g;
const Ie = [];
function Zi(e) {
  return Ie.push(e), () => {
    Ie.splice(Ie.indexOf(e), 1);
  };
}
const ie = ca, q = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Ji(e) {
  if (!e || !ne)
    return;
  const a = O.createElement("style");
  a.setAttribute("type", "text/css"), a.innerHTML = e;
  const t = O.head.childNodes;
  let n = null;
  for (let r = t.length - 1; r > -1; r--) {
    const i = t[r], o = (i.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(o) > -1 && (n = i);
  }
  return O.head.insertBefore(a, n), e;
}
const xi = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function Ee() {
  let e = 12, a = "";
  for (; e-- > 0; )
    a += xi[Math.random() * 62 | 0];
  return a;
}
function Le(e) {
  const a = [];
  for (let t = (e || []).length >>> 0; t--; )
    a[t] = e[t];
  return a;
}
function Oa(e) {
  return e.classList ? Le(e.classList) : (e.getAttribute("class") || "").split(" ").filter((a) => a);
}
function Tt(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function er(e) {
  return Object.keys(e || {}).reduce((a, t) => a + "".concat(t, '="').concat(Tt(e[t]), '" '), "").trim();
}
function Je(e) {
  return Object.keys(e || {}).reduce((a, t) => a + "".concat(t, ": ").concat(e[t].trim(), ";"), "");
}
function Sa(e) {
  return e.size !== q.size || e.x !== q.x || e.y !== q.y || e.rotate !== q.rotate || e.flipX || e.flipY;
}
function ar(e) {
  let {
    transform: a,
    containerWidth: t,
    iconWidth: n
  } = e;
  const r = {
    transform: "translate(".concat(t / 2, " 256)")
  }, i = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), o = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), l = "rotate(".concat(a.rotate, " 0 0)"), c = {
    transform: "".concat(i, " ").concat(o, " ").concat(l)
  }, f = {
    transform: "translate(".concat(n / 2 * -1, " -256)")
  };
  return {
    outer: r,
    inner: c,
    path: f
  };
}
function tr(e) {
  let {
    transform: a,
    width: t = ca,
    height: n = ca,
    startCentered: r = !1
  } = e, i = "";
  return r && wt ? i += "translate(".concat(a.x / ie - t / 2, "em, ").concat(a.y / ie - n / 2, "em) ") : r ? i += "translate(calc(-50% + ".concat(a.x / ie, "em), calc(-50% + ").concat(a.y / ie, "em)) ") : i += "translate(".concat(a.x / ie, "em, ").concat(a.y / ie, "em) "), i += "scale(".concat(a.size / ie * (a.flipX ? -1 : 1), ", ").concat(a.size / ie * (a.flipY ? -1 : 1), ") "), i += "rotate(".concat(a.rotate, "deg) "), i;
}
var nr = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function It() {
  const e = Nt, a = Mt, t = g.cssPrefix, n = g.replacementClass;
  let r = nr;
  if (t !== e || n !== a) {
    const i = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), l = new RegExp("\\.".concat(a), "g");
    r = r.replace(i, ".".concat(t, "-")).replace(o, "--".concat(t, "-")).replace(l, ".".concat(n));
  }
  return r;
}
let Xa = !1;
function na() {
  g.autoAddCss && !Xa && (Ji(It()), Xa = !0);
}
var ir = {
  mixout() {
    return {
      dom: {
        css: It,
        insertCss: na
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        na();
      },
      beforeI2svg() {
        na();
      }
    };
  }
};
const ae = se || {};
ae[ee] || (ae[ee] = {});
ae[ee].styles || (ae[ee].styles = {});
ae[ee].hooks || (ae[ee].hooks = {});
ae[ee].shims || (ae[ee].shims = []);
var Q = ae[ee];
const Rt = [], Ht = function() {
  O.removeEventListener("DOMContentLoaded", Ht), Ye = 1, Rt.map((e) => e());
};
let Ye = !1;
ne && (Ye = (O.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(O.readyState), Ye || O.addEventListener("DOMContentLoaded", Ht));
function rr(e) {
  ne && (Ye ? setTimeout(e, 0) : Rt.push(e));
}
function Be(e) {
  const {
    tag: a,
    attributes: t = {},
    children: n = []
  } = e;
  return typeof e == "string" ? Tt(e) : "<".concat(a, " ").concat(er(t), ">").concat(n.map(Be).join(""), "</").concat(a, ">");
}
function Ka(e, a, t) {
  if (e && e[a] && e[a][t])
    return {
      prefix: a,
      iconName: t,
      icon: e[a][t]
    };
}
var ia = function(a, t, n, r) {
  var i = Object.keys(a), o = i.length, l = t, c, f, s;
  for (n === void 0 ? (c = 1, s = a[i[0]]) : (c = 0, s = n); c < o; c++)
    f = i[c], s = l(s, a[f], f, a);
  return s;
};
function or(e) {
  const a = [];
  let t = 0;
  const n = e.length;
  for (; t < n; ) {
    const r = e.charCodeAt(t++);
    if (r >= 55296 && r <= 56319 && t < n) {
      const i = e.charCodeAt(t++);
      (i & 64512) == 56320 ? a.push(((r & 1023) << 10) + (i & 1023) + 65536) : (a.push(r), t--);
    } else
      a.push(r);
  }
  return a;
}
function ma(e) {
  const a = or(e);
  return a.length === 1 ? a[0].toString(16) : null;
}
function lr(e, a) {
  const t = e.length;
  let n = e.charCodeAt(a), r;
  return n >= 55296 && n <= 56319 && t > a + 1 && (r = e.charCodeAt(a + 1), r >= 56320 && r <= 57343) ? (n - 55296) * 1024 + r - 56320 + 65536 : n;
}
function qa(e) {
  return Object.keys(e).reduce((a, t) => {
    const n = e[t];
    return !!n.icon ? a[n.iconName] = n.icon : a[t] = n, a;
  }, {});
}
function ha(e, a) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: n = !1
  } = t, r = qa(a);
  typeof Q.hooks.addPack == "function" && !n ? Q.hooks.addPack(e, qa(a)) : Q.styles[e] = {
    ...Q.styles[e] || {},
    ...r
  }, e === "fas" && ha("fa", a);
}
const {
  styles: me,
  shims: cr
} = Q, sr = {
  [z]: Object.values(ge[z]),
  [F]: Object.values(ge[F]),
  [U]: Object.values(ge[U])
};
let za = null, $t = {}, Et = {}, Vt = {}, Bt = {}, jt = {};
const fr = {
  [z]: Object.keys(ve[z]),
  [F]: Object.keys(ve[F]),
  [U]: Object.keys(ve[U])
};
function ur(e) {
  return ~Ki.indexOf(e);
}
function dr(e, a) {
  const t = a.split("-"), n = t[0], r = t.slice(1).join("-");
  return n === e && r !== "" && !ur(r) ? r : null;
}
const Ft = () => {
  const e = (n) => ia(me, (r, i, o) => (r[o] = ia(i, n, {}), r), {});
  $t = e((n, r, i) => (r[3] && (n[r[3]] = i), r[2] && r[2].filter((l) => typeof l == "number").forEach((l) => {
    n[l.toString(16)] = i;
  }), n)), Et = e((n, r, i) => (n[i] = i, r[2] && r[2].filter((l) => typeof l == "string").forEach((l) => {
    n[l] = i;
  }), n)), jt = e((n, r, i) => {
    const o = r[2];
    return n[i] = i, o.forEach((l) => {
      n[l] = i;
    }), n;
  });
  const a = "far" in me || g.autoFetchSvg, t = ia(cr, (n, r) => {
    const i = r[0];
    let o = r[1];
    const l = r[2];
    return o === "far" && !a && (o = "fas"), typeof i == "string" && (n.names[i] = {
      prefix: o,
      iconName: l
    }), typeof i == "number" && (n.unicodes[i.toString(16)] = {
      prefix: o,
      iconName: l
    }), n;
  }, {
    names: {},
    unicodes: {}
  });
  Vt = t.names, Bt = t.unicodes, za = xe(g.styleDefault, {
    family: g.familyDefault
  });
};
Zi((e) => {
  za = xe(e.styleDefault, {
    family: g.familyDefault
  });
});
Ft();
function Da(e, a) {
  return ($t[e] || {})[a];
}
function mr(e, a) {
  return (Et[e] || {})[a];
}
function oe(e, a) {
  return (jt[e] || {})[a];
}
function Ut(e) {
  return Vt[e] || {
    prefix: null,
    iconName: null
  };
}
function hr(e) {
  const a = Bt[e], t = Da("fas", e);
  return a || (t ? {
    prefix: "fas",
    iconName: t
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function fe() {
  return za;
}
const Ta = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function xe(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: t = z
  } = a, n = ve[t][e], r = $e[t][e] || $e[t][n], i = e in Q.styles ? e : null;
  return r || i || null;
}
const vr = {
  [z]: Object.keys(ge[z]),
  [F]: Object.keys(ge[F]),
  [U]: Object.keys(ge[U])
};
function ea(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: t = !1
  } = a, n = {
    [z]: "".concat(g.cssPrefix, "-").concat(z),
    [F]: "".concat(g.cssPrefix, "-").concat(F),
    [U]: "".concat(g.cssPrefix, "-").concat(U)
  };
  let r = null, i = z;
  const o = Pi.filter((c) => c !== Pt);
  o.forEach((c) => {
    (e.includes(n[c]) || e.some((f) => vr[c].includes(f))) && (i = c);
  });
  const l = e.reduce((c, f) => {
    const s = dr(g.cssPrefix, f);
    if (me[f] ? (f = sr[i].includes(f) ? Ui[i][f] : f, r = f, c.prefix = f) : fr[i].indexOf(f) > -1 ? (r = f, c.prefix = xe(f, {
      family: i
    })) : s ? c.iconName = s : f !== g.replacementClass && !o.some((m) => f === n[m]) && c.rest.push(f), !t && c.prefix && c.iconName) {
      const m = r === "fa" ? Ut(c.iconName) : {}, d = oe(c.prefix, c.iconName);
      m.prefix && (r = null), c.iconName = m.iconName || d || c.iconName, c.prefix = m.prefix || c.prefix, c.prefix === "far" && !me.far && me.fas && !g.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, Ta());
  return (e.includes("fa-brands") || e.includes("fab")) && (l.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (l.prefix = "fad"), !l.prefix && i === F && (me.fass || g.autoFetchSvg) && (l.prefix = "fass", l.iconName = oe(l.prefix, l.iconName) || l.iconName), !l.prefix && i === U && (me.fasds || g.autoFetchSvg) && (l.prefix = "fasds", l.iconName = oe(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || r === "fa") && (l.prefix = fe() || "fas"), l;
}
class gr {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var a = arguments.length, t = new Array(a), n = 0; n < a; n++)
      t[n] = arguments[n];
    const r = t.reduce(this._pullDefinitions, {});
    Object.keys(r).forEach((i) => {
      this.definitions[i] = {
        ...this.definitions[i] || {},
        ...r[i]
      }, ha(i, r[i]);
      const o = ge[z][i];
      o && ha(o, r[i]), Ft();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(a, t) {
    const n = t.prefix && t.iconName && t.icon ? {
      0: t
    } : t;
    return Object.keys(n).map((r) => {
      const {
        prefix: i,
        iconName: o,
        icon: l
      } = n[r], c = l[2];
      a[i] || (a[i] = {}), c.length > 0 && c.forEach((f) => {
        typeof f == "string" && (a[i][f] = l);
      }), a[i][o] = l;
    }), a;
  }
}
let Qa = [], we = {};
const Pe = {}, br = Object.keys(Pe);
function pr(e, a) {
  let {
    mixoutsTo: t
  } = a;
  return Qa = e, we = {}, Object.keys(Pe).forEach((n) => {
    br.indexOf(n) === -1 && delete Pe[n];
  }), Qa.forEach((n) => {
    const r = n.mixout ? n.mixout() : {};
    if (Object.keys(r).forEach((i) => {
      typeof r[i] == "function" && (t[i] = r[i]), typeof r[i] == "object" && Object.keys(r[i]).forEach((o) => {
        t[i] || (t[i] = {}), t[i][o] = r[i][o];
      });
    }), n.hooks) {
      const i = n.hooks();
      Object.keys(i).forEach((o) => {
        we[o] || (we[o] = []), we[o].push(i[o]);
      });
    }
    n.provides && n.provides(Pe);
  }), t;
}
function va(e, a) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), r = 2; r < t; r++)
    n[r - 2] = arguments[r];
  return (we[e] || []).forEach((o) => {
    a = o.apply(null, [a, ...n]);
  }), a;
}
function pe(e) {
  for (var a = arguments.length, t = new Array(a > 1 ? a - 1 : 0), n = 1; n < a; n++)
    t[n - 1] = arguments[n];
  (we[e] || []).forEach((i) => {
    i.apply(null, t);
  });
}
function ue() {
  const e = arguments[0], a = Array.prototype.slice.call(arguments, 1);
  return Pe[e] ? Pe[e].apply(null, a) : void 0;
}
function ga(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: a
  } = e;
  const t = e.prefix || fe();
  if (a)
    return a = oe(t, a) || a, Ka(Gt.definitions, t, a) || Ka(Q.styles, t, a);
}
const Gt = new gr(), yr = () => {
  g.autoReplaceSvg = !1, g.observeMutations = !1, pe("noAuto");
}, _r = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ne ? (pe("beforeI2svg", e), ue("pseudoElements2svg", e), ue("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: a
    } = e;
    g.autoReplaceSvg === !1 && (g.autoReplaceSvg = !0), g.observeMutations = !0, rr(() => {
      wr({
        autoReplaceSvgRoot: a
      }), pe("watch", e);
    });
  }
}, kr = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: oe(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const a = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], t = xe(e[0]);
      return {
        prefix: t,
        iconName: oe(t, a) || a
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(g.cssPrefix, "-")) > -1 || e.match(Gi))) {
      const a = ea(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || fe(),
        iconName: oe(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof e == "string") {
      const a = fe();
      return {
        prefix: a,
        iconName: oe(a, e) || e
      };
    }
  }
}, G = {
  noAuto: yr,
  config: g,
  dom: _r,
  parse: kr,
  library: Gt,
  findIconDefinition: ga,
  toHtml: Be
}, wr = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: a = O
  } = e;
  (Object.keys(Q.styles).length > 0 || g.autoFetchSvg) && ne && g.autoReplaceSvg && G.dom.i2svg({
    node: a
  });
};
function aa(e, a) {
  return Object.defineProperty(e, "abstract", {
    get: a
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((t) => Be(t));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!ne) return;
      const t = O.createElement("div");
      return t.innerHTML = e.html, t.children;
    }
  }), e;
}
function Pr(e) {
  let {
    children: a,
    main: t,
    mask: n,
    attributes: r,
    styles: i,
    transform: o
  } = e;
  if (Sa(o) && t.found && !n.found) {
    const {
      width: l,
      height: c
    } = t, f = {
      x: l / c / 2,
      y: 0.5
    };
    r.style = Je({
      ...i,
      "transform-origin": "".concat(f.x + o.x / 16, "em ").concat(f.y + o.y / 16, "em")
    });
  }
  return [{
    tag: "svg",
    attributes: r,
    children: a
  }];
}
function Cr(e) {
  let {
    prefix: a,
    iconName: t,
    children: n,
    attributes: r,
    symbol: i
  } = e;
  const o = i === !0 ? "".concat(a, "-").concat(g.cssPrefix, "-").concat(t) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: {
        ...r,
        id: o
      },
      children: n
    }]
  }];
}
function Ia(e) {
  const {
    icons: {
      main: a,
      mask: t
    },
    prefix: n,
    iconName: r,
    transform: i,
    symbol: o,
    title: l,
    maskId: c,
    titleId: f,
    extra: s,
    watchable: m = !1
  } = e, {
    width: d,
    height: _
  } = t.found ? t : a, p = n === "fak", k = [g.replacementClass, r ? "".concat(g.cssPrefix, "-").concat(r) : ""].filter((W) => s.classes.indexOf(W) === -1).filter((W) => W !== "" || !!W).concat(s.classes).join(" ");
  let N = {
    children: [],
    attributes: {
      ...s.attributes,
      "data-prefix": n,
      "data-icon": r,
      class: k,
      role: s.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(_)
    }
  };
  const h = p && !~s.classes.indexOf("fa-fw") ? {
    width: "".concat(d / _ * 16 * 0.0625, "em")
  } : {};
  m && (N.attributes[be] = ""), l && (N.children.push({
    tag: "title",
    attributes: {
      id: N.attributes["aria-labelledby"] || "title-".concat(f || Ee())
    },
    children: [l]
  }), delete N.attributes.title);
  const y = {
    ...N,
    prefix: n,
    iconName: r,
    main: a,
    mask: t,
    maskId: c,
    transform: i,
    symbol: o,
    styles: {
      ...h,
      ...s.styles
    }
  }, {
    children: D,
    attributes: E
  } = t.found && a.found ? ue("generateAbstractMask", y) || {
    children: [],
    attributes: {}
  } : ue("generateAbstractIcon", y) || {
    children: [],
    attributes: {}
  };
  return y.children = D, y.attributes = E, o ? Cr(y) : Pr(y);
}
function Za(e) {
  const {
    content: a,
    width: t,
    height: n,
    transform: r,
    title: i,
    extra: o,
    watchable: l = !1
  } = e, c = {
    ...o.attributes,
    ...i ? {
      title: i
    } : {},
    class: o.classes.join(" ")
  };
  l && (c[be] = "");
  const f = {
    ...o.styles
  };
  Sa(r) && (f.transform = tr({
    transform: r,
    startCentered: !0,
    width: t,
    height: n
  }), f["-webkit-transform"] = f.transform);
  const s = Je(f);
  s.length > 0 && (c.style = s);
  const m = [];
  return m.push({
    tag: "span",
    attributes: c,
    children: [a]
  }), i && m.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), m;
}
function Ar(e) {
  const {
    content: a,
    title: t,
    extra: n
  } = e, r = {
    ...n.attributes,
    ...t ? {
      title: t
    } : {},
    class: n.classes.join(" ")
  }, i = Je(n.styles);
  i.length > 0 && (r.style = i);
  const o = [];
  return o.push({
    tag: "span",
    attributes: r,
    children: [a]
  }), t && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [t]
  }), o;
}
const {
  styles: ra
} = Q;
function ba(e) {
  const a = e[0], t = e[1], [n] = e.slice(4);
  let r = null;
  return Array.isArray(n) ? r = {
    tag: "g",
    attributes: {
      class: "".concat(g.cssPrefix, "-").concat(ta.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(g.cssPrefix, "-").concat(ta.SECONDARY),
        fill: "currentColor",
        d: n[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(g.cssPrefix, "-").concat(ta.PRIMARY),
        fill: "currentColor",
        d: n[1]
      }
    }]
  } : r = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: n
    }
  }, {
    found: !0,
    width: a,
    height: t,
    icon: r
  };
}
const Nr = {
  found: !1,
  width: 512,
  height: 512
};
function Mr(e, a) {
  !Lt && !g.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(a, '" is missing.'));
}
function pa(e, a) {
  let t = a;
  return a === "fa" && g.styleDefault !== null && (a = fe()), new Promise((n, r) => {
    if (t === "fa") {
      const i = Ut(e) || {};
      e = i.iconName || e, a = i.prefix || a;
    }
    if (e && a && ra[a] && ra[a][e]) {
      const i = ra[a][e];
      return n(ba(i));
    }
    Mr(e, a), n({
      ...Nr,
      icon: g.showMissingIcons && e ? ue("missingIconAbstract") || {} : {}
    });
  });
}
const Ja = () => {
}, ya = g.measurePerformance && Fe && Fe.mark && Fe.measure ? Fe : {
  mark: Ja,
  measure: Ja
}, ze = 'FA "6.6.0"', Lr = (e) => (ya.mark("".concat(ze, " ").concat(e, " begins")), () => Wt(e)), Wt = (e) => {
  ya.mark("".concat(ze, " ").concat(e, " ends")), ya.measure("".concat(ze, " ").concat(e), "".concat(ze, " ").concat(e, " begins"), "".concat(ze, " ").concat(e, " ends"));
};
var Ra = {
  begin: Lr,
  end: Wt
};
const Ue = () => {
};
function xa(e) {
  return typeof (e.getAttribute ? e.getAttribute(be) : null) == "string";
}
function Or(e) {
  const a = e.getAttribute ? e.getAttribute(Ma) : null, t = e.getAttribute ? e.getAttribute(La) : null;
  return a && t;
}
function Sr(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(g.replacementClass);
}
function zr() {
  return g.autoReplaceSvg === !0 ? Ge.replace : Ge[g.autoReplaceSvg] || Ge.replace;
}
function Dr(e) {
  return O.createElementNS("http://www.w3.org/2000/svg", e);
}
function Tr(e) {
  return O.createElement(e);
}
function Yt(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: t = e.tag === "svg" ? Dr : Tr
  } = a;
  if (typeof e == "string")
    return O.createTextNode(e);
  const n = t(e.tag);
  return Object.keys(e.attributes || []).forEach(function(i) {
    n.setAttribute(i, e.attributes[i]);
  }), (e.children || []).forEach(function(i) {
    n.appendChild(Yt(i, {
      ceFn: t
    }));
  }), n;
}
function Ir(e) {
  let a = " ".concat(e.outerHTML, " ");
  return a = "".concat(a, "Font Awesome fontawesome.com "), a;
}
const Ge = {
  replace: function(e) {
    const a = e[0];
    if (a.parentNode)
      if (e[1].forEach((t) => {
        a.parentNode.insertBefore(Yt(t), a);
      }), a.getAttribute(be) === null && g.keepOriginalSource) {
        let t = O.createComment(Ir(a));
        a.parentNode.replaceChild(t, a);
      } else
        a.remove();
  },
  nest: function(e) {
    const a = e[0], t = e[1];
    if (~Oa(a).indexOf(g.replacementClass))
      return Ge.replace(e);
    const n = new RegExp("".concat(g.cssPrefix, "-.*"));
    if (delete t[0].attributes.id, t[0].attributes.class) {
      const i = t[0].attributes.class.split(" ").reduce((o, l) => (l === g.replacementClass || l.match(n) ? o.toSvg.push(l) : o.toNode.push(l), o), {
        toNode: [],
        toSvg: []
      });
      t[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? a.removeAttribute("class") : a.setAttribute("class", i.toNode.join(" "));
    }
    const r = t.map((i) => Be(i)).join(`
`);
    a.setAttribute(be, ""), a.innerHTML = r;
  }
};
function et(e) {
  e();
}
function Xt(e, a) {
  const t = typeof a == "function" ? a : Ue;
  if (e.length === 0)
    t();
  else {
    let n = et;
    g.mutateApproach === ji && (n = se.requestAnimationFrame || et), n(() => {
      const r = zr(), i = Ra.begin("mutate");
      e.map(r), i(), t();
    });
  }
}
let Ha = !1;
function Kt() {
  Ha = !0;
}
function _a() {
  Ha = !1;
}
let Xe = null;
function at(e) {
  if (!Ua || !g.observeMutations)
    return;
  const {
    treeCallback: a = Ue,
    nodeCallback: t = Ue,
    pseudoElementsCallback: n = Ue,
    observeMutationsRoot: r = O
  } = e;
  Xe = new Ua((i) => {
    if (Ha) return;
    const o = fe();
    Le(i).forEach((l) => {
      if (l.type === "childList" && l.addedNodes.length > 0 && !xa(l.addedNodes[0]) && (g.searchPseudoElements && n(l.target), a(l.target)), l.type === "attributes" && l.target.parentNode && g.searchPseudoElements && n(l.target.parentNode), l.type === "attributes" && xa(l.target) && ~Xi.indexOf(l.attributeName))
        if (l.attributeName === "class" && Or(l.target)) {
          const {
            prefix: c,
            iconName: f
          } = ea(Oa(l.target));
          l.target.setAttribute(Ma, c || o), f && l.target.setAttribute(La, f);
        } else Sr(l.target) && t(l.target);
    });
  }), ne && Xe.observe(r, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function Rr() {
  Xe && Xe.disconnect();
}
function Hr(e) {
  const a = e.getAttribute("style");
  let t = [];
  return a && (t = a.split(";").reduce((n, r) => {
    const i = r.split(":"), o = i[0], l = i.slice(1);
    return o && l.length > 0 && (n[o] = l.join(":").trim()), n;
  }, {})), t;
}
function $r(e) {
  const a = e.getAttribute("data-prefix"), t = e.getAttribute("data-icon"), n = e.innerText !== void 0 ? e.innerText.trim() : "";
  let r = ea(Oa(e));
  return r.prefix || (r.prefix = fe()), a && t && (r.prefix = a, r.iconName = t), r.iconName && r.prefix || (r.prefix && n.length > 0 && (r.iconName = mr(r.prefix, e.innerText) || Da(r.prefix, ma(e.innerText))), !r.iconName && g.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (r.iconName = e.firstChild.data)), r;
}
function Er(e) {
  const a = Le(e.attributes).reduce((r, i) => (r.name !== "class" && r.name !== "style" && (r[i.name] = i.value), r), {}), t = e.getAttribute("title"), n = e.getAttribute("data-fa-title-id");
  return g.autoA11y && (t ? a["aria-labelledby"] = "".concat(g.replacementClass, "-title-").concat(n || Ee()) : (a["aria-hidden"] = "true", a.focusable = "false")), a;
}
function Vr() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: q,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function tt(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: t,
    prefix: n,
    rest: r
  } = $r(e), i = Er(e), o = va("parseNodeAttributes", {}, e);
  let l = a.styleParser ? Hr(e) : [];
  return {
    iconName: t,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: n,
    transform: q,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: r,
      styles: l,
      attributes: i
    },
    ...o
  };
}
const {
  styles: Br
} = Q;
function qt(e) {
  const a = g.autoReplaceSvg === "nest" ? tt(e, {
    styleParser: !1
  }) : tt(e);
  return ~a.extra.classes.indexOf(zt) ? ue("generateLayersText", e, a) : ue("generateSvgReplacementMutation", e, a);
}
let J = /* @__PURE__ */ new Set();
Ot.map((e) => {
  J.add("fa-".concat(e));
});
Object.keys(ve[z]).map(J.add.bind(J));
Object.keys(ve[F]).map(J.add.bind(J));
Object.keys(ve[U]).map(J.add.bind(J));
J = [...J];
function nt(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!ne) return Promise.resolve();
  const t = O.documentElement.classList, n = (s) => t.add("".concat(Ya, "-").concat(s)), r = (s) => t.remove("".concat(Ya, "-").concat(s)), i = g.autoFetchSvg ? J : Ot.map((s) => "fa-".concat(s)).concat(Object.keys(Br));
  i.includes("fa") || i.push("fa");
  const o = [".".concat(zt, ":not([").concat(be, "])")].concat(i.map((s) => ".".concat(s, ":not([").concat(be, "])"))).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  let l = [];
  try {
    l = Le(e.querySelectorAll(o));
  } catch {
  }
  if (l.length > 0)
    n("pending"), r("complete");
  else
    return Promise.resolve();
  const c = Ra.begin("onTree"), f = l.reduce((s, m) => {
    try {
      const d = qt(m);
      d && s.push(d);
    } catch (d) {
      Lt || d.name === "MissingIcon" && console.error(d);
    }
    return s;
  }, []);
  return new Promise((s, m) => {
    Promise.all(f).then((d) => {
      Xt(d, () => {
        n("active"), n("complete"), r("pending"), typeof a == "function" && a(), c(), s();
      });
    }).catch((d) => {
      c(), m(d);
    });
  });
}
function jr(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  qt(e).then((t) => {
    t && Xt([t], a);
  });
}
function Fr(e) {
  return function(a) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = (a || {}).icon ? a : ga(a || {});
    let {
      mask: r
    } = t;
    return r && (r = (r || {}).icon ? r : ga(r || {})), e(n, {
      ...t,
      mask: r
    });
  };
}
const Ur = function(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: t = q,
    symbol: n = !1,
    mask: r = null,
    maskId: i = null,
    title: o = null,
    titleId: l = null,
    classes: c = [],
    attributes: f = {},
    styles: s = {}
  } = a;
  if (!e) return;
  const {
    prefix: m,
    iconName: d,
    icon: _
  } = e;
  return aa({
    type: "icon",
    ...e
  }, () => (pe("beforeDOMElementCreation", {
    iconDefinition: e,
    params: a
  }), g.autoA11y && (o ? f["aria-labelledby"] = "".concat(g.replacementClass, "-title-").concat(l || Ee()) : (f["aria-hidden"] = "true", f.focusable = "false")), Ia({
    icons: {
      main: ba(_),
      mask: r ? ba(r.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: m,
    iconName: d,
    transform: {
      ...q,
      ...t
    },
    symbol: n,
    title: o,
    maskId: i,
    titleId: l,
    extra: {
      attributes: f,
      styles: s,
      classes: c
    }
  })));
};
var Gr = {
  mixout() {
    return {
      icon: Fr(Ur)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = nt, e.nodeCallback = jr, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(a) {
      const {
        node: t = O,
        callback: n = () => {
        }
      } = a;
      return nt(t, n);
    }, e.generateSvgReplacementMutation = function(a, t) {
      const {
        iconName: n,
        title: r,
        titleId: i,
        prefix: o,
        transform: l,
        symbol: c,
        mask: f,
        maskId: s,
        extra: m
      } = t;
      return new Promise((d, _) => {
        Promise.all([pa(n, o), f.iconName ? pa(f.iconName, f.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((p) => {
          let [k, N] = p;
          d([a, Ia({
            icons: {
              main: k,
              mask: N
            },
            prefix: o,
            iconName: n,
            transform: l,
            symbol: c,
            maskId: s,
            title: r,
            titleId: i,
            extra: m,
            watchable: !0
          })]);
        }).catch(_);
      });
    }, e.generateAbstractIcon = function(a) {
      let {
        children: t,
        attributes: n,
        main: r,
        transform: i,
        styles: o
      } = a;
      const l = Je(o);
      l.length > 0 && (n.style = l);
      let c;
      return Sa(i) && (c = ue("generateAbstractTransformGrouping", {
        main: r,
        transform: i,
        containerWidth: r.width,
        iconWidth: r.width
      })), t.push(c || r.icon), {
        children: t,
        attributes: n
      };
    };
  }
}, Wr = {
  mixout() {
    return {
      layer(e) {
        let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: t = []
        } = a;
        return aa({
          type: "layer"
        }, () => {
          pe("beforeDOMElementCreation", {
            assembler: e,
            params: a
          });
          let n = [];
          return e((r) => {
            Array.isArray(r) ? r.map((i) => {
              n = n.concat(i.abstract);
            }) : n = n.concat(r.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(g.cssPrefix, "-layers"), ...t].join(" ")
            },
            children: n
          }];
        });
      }
    };
  }
}, Yr = {
  mixout() {
    return {
      counter(e) {
        let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: t = null,
          classes: n = [],
          attributes: r = {},
          styles: i = {}
        } = a;
        return aa({
          type: "counter",
          content: e
        }, () => (pe("beforeDOMElementCreation", {
          content: e,
          params: a
        }), Ar({
          content: e.toString(),
          title: t,
          extra: {
            attributes: r,
            styles: i,
            classes: ["".concat(g.cssPrefix, "-layers-counter"), ...n]
          }
        })));
      }
    };
  }
}, Xr = {
  mixout() {
    return {
      text(e) {
        let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: t = q,
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: o = {}
        } = a;
        return aa({
          type: "text",
          content: e
        }, () => (pe("beforeDOMElementCreation", {
          content: e,
          params: a
        }), Za({
          content: e,
          transform: {
            ...q,
            ...t
          },
          title: n,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(g.cssPrefix, "-layers-text"), ...r]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(a, t) {
      const {
        title: n,
        transform: r,
        extra: i
      } = t;
      let o = null, l = null;
      if (wt) {
        const c = parseInt(getComputedStyle(a).fontSize, 10), f = a.getBoundingClientRect();
        o = f.width / c, l = f.height / c;
      }
      return g.autoA11y && !n && (i.attributes["aria-hidden"] = "true"), Promise.resolve([a, Za({
        content: a.innerHTML,
        width: o,
        height: l,
        transform: r,
        title: n,
        extra: i,
        watchable: !0
      })]);
    };
  }
};
const Kr = new RegExp('"', "ug"), it = [1105920, 1112319], rt = {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  },
  ...Oi,
  ...Li,
  ...$i
}, ka = Object.keys(rt).reduce((e, a) => (e[a.toLowerCase()] = rt[a], e), {}), qr = Object.keys(ka).reduce((e, a) => {
  const t = ka[a];
  return e[a] = t[900] || [...Object.entries(t)][0][1], e;
}, {});
function Qr(e) {
  const a = e.replace(Kr, ""), t = lr(a, 0), n = t >= it[0] && t <= it[1], r = a.length === 2 ? a[0] === a[1] : !1;
  return {
    value: ma(r ? a[0] : a),
    isSecondary: n || r
  };
}
function Zr(e, a) {
  const t = e.replace(/^['"]|['"]$/g, "").toLowerCase(), n = parseInt(a), r = isNaN(n) ? "normal" : n;
  return (ka[t] || {})[r] || qr[t];
}
function ot(e, a) {
  const t = "".concat(Bi).concat(a.replace(":", "-"));
  return new Promise((n, r) => {
    if (e.getAttribute(t) !== null)
      return n();
    const o = Le(e.children).filter((d) => d.getAttribute(sa) === a)[0], l = se.getComputedStyle(e, a), c = l.getPropertyValue("font-family"), f = c.match(Wi), s = l.getPropertyValue("font-weight"), m = l.getPropertyValue("content");
    if (o && !f)
      return e.removeChild(o), n();
    if (f && m !== "none" && m !== "") {
      const d = l.getPropertyValue("content");
      let _ = Zr(c, s);
      const {
        value: p,
        isSecondary: k
      } = Qr(d), N = f[0].startsWith("FontAwesome");
      let h = Da(_, p), y = h;
      if (N) {
        const D = hr(p);
        D.iconName && D.prefix && (h = D.iconName, _ = D.prefix);
      }
      if (h && !k && (!o || o.getAttribute(Ma) !== _ || o.getAttribute(La) !== y)) {
        e.setAttribute(t, y), o && e.removeChild(o);
        const D = Vr(), {
          extra: E
        } = D;
        E.attributes[sa] = a, pa(h, _).then((W) => {
          const je = Ia({
            ...D,
            icons: {
              main: W,
              mask: Ta()
            },
            prefix: _,
            iconName: y,
            extra: E,
            watchable: !0
          }), de = O.createElementNS("http://www.w3.org/2000/svg", "svg");
          a === "::before" ? e.insertBefore(de, e.firstChild) : e.appendChild(de), de.outerHTML = je.map((di) => Be(di)).join(`
`), e.removeAttribute(t), n();
        }).catch(r);
      } else
        n();
    } else
      n();
  });
}
function Jr(e) {
  return Promise.all([ot(e, "::before"), ot(e, "::after")]);
}
function xr(e) {
  return e.parentNode !== document.head && !~Fi.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(sa) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function lt(e) {
  if (ne)
    return new Promise((a, t) => {
      const n = Le(e.querySelectorAll("*")).filter(xr).map(Jr), r = Ra.begin("searchPseudoElements");
      Kt(), Promise.all(n).then(() => {
        r(), _a(), a();
      }).catch(() => {
        r(), _a(), t();
      });
    });
}
var eo = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = lt, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(a) {
      const {
        node: t = O
      } = a;
      g.searchPseudoElements && lt(t);
    };
  }
};
let ct = !1;
var ao = {
  mixout() {
    return {
      dom: {
        unwatch() {
          Kt(), ct = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        at(va("mutationObserverCallbacks", {}));
      },
      noAuto() {
        Rr();
      },
      watch(e) {
        const {
          observeMutationsRoot: a
        } = e;
        ct ? _a() : at(va("mutationObserverCallbacks", {
          observeMutationsRoot: a
        }));
      }
    };
  }
};
const st = (e) => {
  let a = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((t, n) => {
    const r = n.toLowerCase().split("-"), i = r[0];
    let o = r.slice(1).join("-");
    if (i && o === "h")
      return t.flipX = !0, t;
    if (i && o === "v")
      return t.flipY = !0, t;
    if (o = parseFloat(o), isNaN(o))
      return t;
    switch (i) {
      case "grow":
        t.size = t.size + o;
        break;
      case "shrink":
        t.size = t.size - o;
        break;
      case "left":
        t.x = t.x - o;
        break;
      case "right":
        t.x = t.x + o;
        break;
      case "up":
        t.y = t.y - o;
        break;
      case "down":
        t.y = t.y + o;
        break;
      case "rotate":
        t.rotate = t.rotate + o;
        break;
    }
    return t;
  }, a);
};
var to = {
  mixout() {
    return {
      parse: {
        transform: (e) => st(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, a) {
        const t = a.getAttribute("data-fa-transform");
        return t && (e.transform = st(t)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(a) {
      let {
        main: t,
        transform: n,
        containerWidth: r,
        iconWidth: i
      } = a;
      const o = {
        transform: "translate(".concat(r / 2, " 256)")
      }, l = "translate(".concat(n.x * 32, ", ").concat(n.y * 32, ") "), c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "), f = "rotate(".concat(n.rotate, " 0 0)"), s = {
        transform: "".concat(l, " ").concat(c, " ").concat(f)
      }, m = {
        transform: "translate(".concat(i / 2 * -1, " -256)")
      }, d = {
        outer: o,
        inner: s,
        path: m
      };
      return {
        tag: "g",
        attributes: {
          ...d.outer
        },
        children: [{
          tag: "g",
          attributes: {
            ...d.inner
          },
          children: [{
            tag: t.icon.tag,
            children: t.icon.children,
            attributes: {
              ...t.icon.attributes,
              ...d.path
            }
          }]
        }]
      };
    };
  }
};
const oa = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function ft(e) {
  let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || a) && (e.attributes.fill = "black"), e;
}
function no(e) {
  return e.tag === "g" ? e.children : [e];
}
var io = {
  hooks() {
    return {
      parseNodeAttributes(e, a) {
        const t = a.getAttribute("data-fa-mask"), n = t ? ea(t.split(" ").map((r) => r.trim())) : Ta();
        return n.prefix || (n.prefix = fe()), e.mask = n, e.maskId = a.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(a) {
      let {
        children: t,
        attributes: n,
        main: r,
        mask: i,
        maskId: o,
        transform: l
      } = a;
      const {
        width: c,
        icon: f
      } = r, {
        width: s,
        icon: m
      } = i, d = ar({
        transform: l,
        containerWidth: s,
        iconWidth: c
      }), _ = {
        tag: "rect",
        attributes: {
          ...oa,
          fill: "white"
        }
      }, p = f.children ? {
        children: f.children.map(ft)
      } : {}, k = {
        tag: "g",
        attributes: {
          ...d.inner
        },
        children: [ft({
          tag: f.tag,
          attributes: {
            ...f.attributes,
            ...d.path
          },
          ...p
        })]
      }, N = {
        tag: "g",
        attributes: {
          ...d.outer
        },
        children: [k]
      }, h = "mask-".concat(o || Ee()), y = "clip-".concat(o || Ee()), D = {
        tag: "mask",
        attributes: {
          ...oa,
          id: h,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        },
        children: [_, N]
      }, E = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: y
          },
          children: no(m)
        }, D]
      };
      return t.push(E, {
        tag: "rect",
        attributes: {
          fill: "currentColor",
          "clip-path": "url(#".concat(y, ")"),
          mask: "url(#".concat(h, ")"),
          ...oa
        }
      }), {
        children: t,
        attributes: n
      };
    };
  }
}, ro = {
  provides(e) {
    let a = !1;
    se.matchMedia && (a = se.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const t = [], n = {
        fill: "currentColor"
      }, r = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      t.push({
        tag: "path",
        attributes: {
          ...n,
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        }
      });
      const i = {
        ...r,
        attributeName: "opacity"
      }, o = {
        tag: "circle",
        attributes: {
          ...n,
          cx: "256",
          cy: "364",
          r: "28"
        },
        children: []
      };
      return a || o.children.push({
        tag: "animate",
        attributes: {
          ...r,
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        }
      }, {
        tag: "animate",
        attributes: {
          ...i,
          values: "1;0;1;1;0;1;"
        }
      }), t.push(o), t.push({
        tag: "path",
        attributes: {
          ...n,
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        },
        children: a ? [] : [{
          tag: "animate",
          attributes: {
            ...i,
            values: "1;0;0;0;0;1;"
          }
        }]
      }), a || t.push({
        tag: "path",
        attributes: {
          ...n,
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        },
        children: [{
          tag: "animate",
          attributes: {
            ...i,
            values: "0;0;1;1;0;0;"
          }
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: t
      };
    };
  }
}, oo = {
  hooks() {
    return {
      parseNodeAttributes(e, a) {
        const t = a.getAttribute("data-fa-symbol"), n = t === null ? !1 : t === "" ? !0 : t;
        return e.symbol = n, e;
      }
    };
  }
}, lo = [ir, Gr, Wr, Yr, Xr, eo, ao, to, io, ro, oo];
pr(lo, {
  mixoutsTo: G
});
G.noAuto;
const Qt = G.config, co = G.library;
G.dom;
const Ke = G.parse;
G.findIconDefinition;
G.toHtml;
const so = G.icon;
G.layer;
const fo = G.text;
G.counter;
function ut(e, a) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    a && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function X(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a] != null ? arguments[a] : {};
    a % 2 ? ut(Object(t), !0).forEach(function(n) {
      B(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ut(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function uo(e, a) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, a || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(e);
}
function mo(e) {
  var a = uo(e, "string");
  return typeof a == "symbol" ? a : a + "";
}
function qe(e) {
  "@babel/helpers - typeof";
  return qe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, qe(e);
}
function B(e, a, t) {
  return a = mo(a), a in e ? Object.defineProperty(e, a, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[a] = t, e;
}
function ho(e, a) {
  if (e == null) return {};
  var t = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (a.indexOf(n) >= 0) continue;
      t[n] = e[n];
    }
  return t;
}
function vo(e, a) {
  if (e == null) return {};
  var t = ho(e, a), n, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], !(a.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function wa(e) {
  return go(e) || bo(e) || po(e) || yo();
}
function go(e) {
  if (Array.isArray(e)) return Pa(e);
}
function bo(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function po(e, a) {
  if (e) {
    if (typeof e == "string") return Pa(e, a);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Pa(e, a);
  }
}
function Pa(e, a) {
  (a == null || a > e.length) && (a = e.length);
  for (var t = 0, n = new Array(a); t < a; t++) n[t] = e[t];
  return n;
}
function yo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var _o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Zt = { exports: {} };
(function(e) {
  (function(a) {
    var t = function(h, y, D) {
      if (!f(y) || m(y) || d(y) || _(y) || c(y))
        return y;
      var E, W = 0, je = 0;
      if (s(y))
        for (E = [], je = y.length; W < je; W++)
          E.push(t(h, y[W], D));
      else {
        E = {};
        for (var de in y)
          Object.prototype.hasOwnProperty.call(y, de) && (E[h(de, D)] = t(h, y[de], D));
      }
      return E;
    }, n = function(h, y) {
      y = y || {};
      var D = y.separator || "_", E = y.split || /(?=[A-Z])/;
      return h.split(E).join(D);
    }, r = function(h) {
      return p(h) ? h : (h = h.replace(/[\-_\s]+(.)?/g, function(y, D) {
        return D ? D.toUpperCase() : "";
      }), h.substr(0, 1).toLowerCase() + h.substr(1));
    }, i = function(h) {
      var y = r(h);
      return y.substr(0, 1).toUpperCase() + y.substr(1);
    }, o = function(h, y) {
      return n(h, y).toLowerCase();
    }, l = Object.prototype.toString, c = function(h) {
      return typeof h == "function";
    }, f = function(h) {
      return h === Object(h);
    }, s = function(h) {
      return l.call(h) == "[object Array]";
    }, m = function(h) {
      return l.call(h) == "[object Date]";
    }, d = function(h) {
      return l.call(h) == "[object RegExp]";
    }, _ = function(h) {
      return l.call(h) == "[object Boolean]";
    }, p = function(h) {
      return h = h - 0, h === h;
    }, k = function(h, y) {
      var D = y && "process" in y ? y.process : y;
      return typeof D != "function" ? h : function(E, W) {
        return D(E, h, W);
      };
    }, N = {
      camelize: r,
      decamelize: o,
      pascalize: i,
      depascalize: o,
      camelizeKeys: function(h, y) {
        return t(k(r, y), h);
      },
      decamelizeKeys: function(h, y) {
        return t(k(o, y), h, y);
      },
      pascalizeKeys: function(h, y) {
        return t(k(i, y), h);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    e.exports ? e.exports = N : a.humps = N;
  })(_o);
})(Zt);
var ko = Zt.exports, wo = ["class", "style"];
function Po(e) {
  return e.split(";").map(function(a) {
    return a.trim();
  }).filter(function(a) {
    return a;
  }).reduce(function(a, t) {
    var n = t.indexOf(":"), r = ko.camelize(t.slice(0, n)), i = t.slice(n + 1).trim();
    return a[r] = i, a;
  }, {});
}
function Co(e) {
  return e.split(/\s+/).reduce(function(a, t) {
    return a[t] = !0, a;
  }, {});
}
function $a(e) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var n = (e.children || []).map(function(c) {
    return $a(c);
  }), r = Object.keys(e.attributes || {}).reduce(function(c, f) {
    var s = e.attributes[f];
    switch (f) {
      case "class":
        c.class = Co(s);
        break;
      case "style":
        c.style = Po(s);
        break;
      default:
        c.attrs[f] = s;
    }
    return c;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  t.class;
  var i = t.style, o = i === void 0 ? {} : i, l = vo(t, wo);
  return vt(e.tag, X(X(X({}, a), {}, {
    class: r.class,
    style: X(X({}, r.style), o)
  }, r.attrs), l), n);
}
var Jt = !1;
try {
  Jt = process.env.NODE_ENV === "production";
} catch {
}
function Ao() {
  if (!Jt && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function Re(e, a) {
  return Array.isArray(a) && a.length > 0 || !Array.isArray(a) && a ? B({}, e, a) : {};
}
function No(e) {
  var a, t = (a = {
    "fa-spin": e.spin,
    "fa-pulse": e.pulse,
    "fa-fw": e.fixedWidth,
    "fa-border": e.border,
    "fa-li": e.listItem,
    "fa-inverse": e.inverse,
    "fa-flip": e.flip === !0,
    "fa-flip-horizontal": e.flip === "horizontal" || e.flip === "both",
    "fa-flip-vertical": e.flip === "vertical" || e.flip === "both"
  }, B(B(B(B(B(B(B(B(B(B(a, "fa-".concat(e.size), e.size !== null), "fa-rotate-".concat(e.rotation), e.rotation !== null), "fa-pull-".concat(e.pull), e.pull !== null), "fa-swap-opacity", e.swapOpacity), "fa-bounce", e.bounce), "fa-shake", e.shake), "fa-beat", e.beat), "fa-fade", e.fade), "fa-beat-fade", e.beatFade), "fa-flash", e.flash), B(B(a, "fa-spin-pulse", e.spinPulse), "fa-spin-reverse", e.spinReverse));
  return Object.keys(t).map(function(n) {
    return t[n] ? n : null;
  }).filter(function(n) {
    return n;
  });
}
function dt(e) {
  if (e && qe(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (Ke.icon)
    return Ke.icon(e);
  if (e === null)
    return null;
  if (qe(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
var Ca = L({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(a) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(a) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(a) {
        return ["right", "left"].indexOf(a) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(a) {
        return [90, 180, 270].indexOf(Number.parseInt(a, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(a) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(a) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(a, t) {
    var n = t.attrs, r = P(function() {
      return dt(a.icon);
    }), i = P(function() {
      return Re("classes", No(a));
    }), o = P(function() {
      return Re("transform", typeof a.transform == "string" ? Ke.transform(a.transform) : a.transform);
    }), l = P(function() {
      return Re("mask", dt(a.mask));
    }), c = P(function() {
      return so(r.value, X(X(X(X({}, i.value), o.value), l.value), {}, {
        symbol: a.symbol,
        title: a.title,
        titleId: a.titleId,
        maskId: a.maskId
      }));
    });
    Z(c, function(s) {
      if (!s)
        return Ao("Could not find one or more icon(s)", r.value, l.value);
    }, {
      immediate: !0
    });
    var f = P(function() {
      return c.value ? $a(c.value.abstract[0], {}, n) : null;
    });
    return function() {
      return f.value;
    };
  }
});
L({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(a, t) {
    var n = t.slots, r = Qt.familyPrefix, i = P(function() {
      return ["".concat(r, "-layers")].concat(wa(a.fixedWidth ? ["".concat(r, "-fw")] : []));
    });
    return function() {
      return vt("div", {
        class: i.value
      }, n.default ? n.default() : []);
    };
  }
});
L({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(a) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(a) > -1;
      }
    }
  },
  setup: function(a, t) {
    var n = t.attrs, r = Qt.familyPrefix, i = P(function() {
      return Re("classes", [].concat(wa(a.counter ? ["".concat(r, "-layers-counter")] : []), wa(a.position ? ["".concat(r, "-layers-").concat(a.position)] : [])));
    }), o = P(function() {
      return Re("transform", typeof a.transform == "string" ? Ke.transform(a.transform) : a.transform);
    }), l = P(function() {
      var f = fo(a.value.toString(), X(X({}, o.value), i.value)), s = f.abstract;
      return a.counter && (s[0].attributes.class = s[0].attributes.class.replace("fa-layers-text", "")), s[0];
    }), c = P(function() {
      return $a(l.value, {}, n);
    });
    return function() {
      return c.value;
    };
  }
});
const Mo = ["disabled"], Lo = {
  key: 0,
  class: "icon-left"
}, Oo = { class: "label-slot" }, So = {
  key: 1,
  class: "icon-right"
}, zo = /* @__PURE__ */ L({
  __name: "AlcButton",
  props: {
    corners: { default: "rounded" },
    disabled: { type: Boolean, default: !1 },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    label: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    size: { default: re.MEDIUM },
    stretch: { type: Boolean, default: !1 },
    variant: { default: Ce.PRIMARY }
  },
  emits: ["alc-btn-click"],
  setup(e, { emit: a }) {
    te((c) => ({
      "07a01990": l.value,
      d525f0ba: o.value
    }));
    const t = e, n = a;
    function r() {
      n("alc-btn-click");
    }
    const i = P(() => {
      const c = [];
      return c.push(t.variant), t.variant === Ce.TERTIARY && t.selected && c.push("tertiary--selected"), t.label ? c.push(t.size) : (t.iconLeft || t.iconRight) && c.push(t.size + "--icon-only"), c;
    }), o = P(() => t.stretch ? "100%" : "auto"), l = P(() => t.corners === "rounded" ? "4px" : "0");
    return (c, f) => (u(), b("button", {
      class: C(["alc-button", i.value]),
      disabled: c.disabled,
      onClick: r
    }, [
      c.iconLeft ? (u(), b("div", Lo, [
        T(w(Ca), { icon: c.iconLeft }, null, 8, ["icon"])
      ])) : A("", !0),
      v("div", Oo, [
        j(c.$slots, "default", {}, () => [
          le(I(c.label), 1)
        ], !0)
      ]),
      c.iconRight ? (u(), b("div", So, [
        T(w(Ca), { icon: c.iconRight }, null, 8, ["icon"])
      ])) : A("", !0)
    ], 10, Mo));
  }
}), he = /* @__PURE__ */ $(zo, [["__scopeId", "data-v-13f1d167"]]), Do = { class: "icon__wrapper" }, To = { class: "alc-icon__icon" }, Io = /* @__PURE__ */ L({
  __name: "AlcIcon",
  props: {
    icon: {},
    iconBackgroundColor: { default: H.GOLD },
    iconColor: { default: H.WHITE },
    iconShape: { default: ce.ROUND },
    iconSize: { default: He.MEDIUM }
  },
  setup(e) {
    te((l) => ({
      "4ad5f4a2": t.value,
      c583e3ba: n.value,
      "77e2e5e2": r.value,
      "52da7734": o.value,
      "1453c656": i.value
    }));
    const a = e, t = P(() => `${+a.iconSize * 1.7}px`), n = P(() => `var(${a.iconBackgroundColor})`), r = P(() => `var(${a.iconColor})`), i = P(() => `${a.iconSize}px`), o = P(() => `${a.iconShape === ce.SQUARE ? "4px" : "50%"}`);
    return (l, c) => {
      const f = K("FontAwesomeIcon");
      return u(), b("div", Do, [
        v("div", To, [
          T(f, { icon: l.icon }, null, 8, ["icon"])
        ])
      ]);
    };
  }
}), x = /* @__PURE__ */ $(Io, [["__scopeId", "data-v-04ed2439"]]), Ro = {
  key: 0,
  class: "alc-card-base__loading"
}, Ho = /* @__PURE__ */ v("div", { class: "alc-card-base__loading-lines" }, [
  /* @__PURE__ */ v("div", { class: "alc-card-base__loading_line_1" }),
  /* @__PURE__ */ v("div", { class: "alc-card-base__loading_line_2" })
], -1), $o = { class: "alc-card-base__body" }, Eo = { class: "alc-card-base__title" }, Vo = {
  key: 0,
  class: "alc-card-base__description"
}, Bo = /* @__PURE__ */ L({
  __name: "AlcCardBase",
  props: {
    title: { default: "" },
    description: { default: "" },
    button: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    iconColor: { default: H.WHITE },
    iconBackgroundColor: { default: H.AQUA },
    iconSize: { default: He.LARGE },
    iconShape: { default: ce.SQUARE },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["alc-card-click"],
  setup(e, { emit: a }) {
    const t = e, n = P(() => t.description ? "alc-card-base__left" : "alc-card-base__left alc-card-base__left--no-description"), r = a, i = () => {
      t.button && r("alc-card-click");
    };
    return (o, l) => (u(), b("div", {
      class: C(["alc-card-base", { "alc-card-base--button": o.button }]),
      onClick: i
    }, [
      o.loading ? (u(), b("div", Ro, [
        T(x, {
          class: "alc-card-base__loading-icon",
          icon: w(R).Circle,
          "icon-color": w(H).NONE,
          "icon-background-color": w(H).INFOLIGHT,
          "icon-size": o.iconSize,
          "icon-shape": w(ce).ROUND
        }, null, 8, ["icon", "icon-color", "icon-background-color", "icon-size", "icon-shape"]),
        Ho
      ])) : (u(), b("div", {
        key: 1,
        class: C(n.value)
      }, [
        o.icon ? (u(), M(x, {
          key: 0,
          class: "alc-card-base__icon",
          icon: o.icon,
          "icon-color": o.iconColor,
          "icon-background-color": o.iconBackgroundColor,
          "icon-size": o.iconSize,
          "icon-shape": o.iconShape
        }, null, 8, ["icon", "icon-color", "icon-background-color", "icon-size", "icon-shape"])) : A("", !0),
        v("div", $o, [
          v("div", Eo, I(o.title), 1),
          o.description ? (u(), b("div", Vo, I(o.description), 1)) : A("", !0)
        ])
      ], 2)),
      o.button ? (u(), M(x, {
        key: 2,
        class: "alc-card-base__arrow",
        icon: w(R).AngleRight,
        "icon-color": w(H).LIGHTGRAY,
        "icon-size": w(He).MEDIUM,
        "icon-background-color": w(H).NONE
      }, null, 8, ["icon", "icon-color", "icon-size", "icon-background-color"])) : A("", !0)
    ], 2));
  }
}), jo = { class: "content-menu-item__text" }, Fo = /* @__PURE__ */ L({
  __name: "AlcContextMenuItem",
  props: {
    icon: { default: R.ExternalLink },
    text: { default: "Test text" }
  },
  emits: ["context-item-click"],
  setup(e, { emit: a }) {
    const t = a, n = () => {
      t("context-item-click");
    };
    return (r, i) => (u(), b("div", {
      class: "content-menu-item",
      onClick: n
    }, [
      r.icon ? (u(), M(x, {
        key: 0,
        class: "content-menu-item__icon",
        icon: r.icon,
        "icon-background-color": w(H).INHERIT,
        "icon-color": w(H).INHERIT
      }, null, 8, ["icon", "icon-background-color", "icon-color"])) : A("", !0),
      v("div", jo, [
        j(r.$slots, "default", {}, () => [
          le(I(r.text), 1)
        ], !0)
      ])
    ]));
  }
}), Uo = /* @__PURE__ */ $(Fo, [["__scopeId", "data-v-eb29631f"]]), Go = { class: "context-menu" }, Wo = { key: 0 }, Yo = /* @__PURE__ */ L({
  __name: "AlcContextMenu",
  props: {
    items: { default: void 0 },
    position: { default: "right" }
  },
  setup(e) {
    const a = e, t = S(!1), n = () => {
      t.value = !t.value;
    }, r = P(() => `context-menu__actions--${a.position}`);
    return (i, o) => (u(), b("div", Go, [
      T(x, {
        icon: w(R).EllipsisVertical,
        "icon-background-color": w(H).NONE,
        "icon-color": w(H).BASE,
        onAlcIconClick: n
      }, null, 8, ["icon", "icon-background-color", "icon-color"]),
      T(Qe, { name: "fade" }, {
        default: Me(() => [
          V(v("div", {
            class: C(["context-menu__actions", r.value])
          }, [
            j(i.$slots, "default", {}, () => [
              i.items ? (u(), b("div", Wo, [
                (u(!0), b(ye, null, _e(i.items, (l) => (u(), M(Uo, {
                  key: l.id,
                  text: l.text,
                  icon: l.icon,
                  onContextItemClick: l.clickHandler
                }, null, 8, ["text", "icon", "onContextItemClick"]))), 128))
              ])) : A("", !0)
            ], !0)
          ], 2), [
            [Y, t.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}), Xo = /* @__PURE__ */ $(Yo, [["__scopeId", "data-v-6efff526"]]), Ko = /* @__PURE__ */ L({
  __name: "AlcEditableText",
  props: {
    text: { default: "" }
  },
  setup(e) {
    let t = S(e.text), n = S(!1), r = S(!1), i = S(!0);
    const o = () => {
      n.value = !1, i.value = !0;
    }, l = () => {
      n.value = !0, i.value = !1;
    }, c = () => {
      r.value = !0;
    }, f = () => {
      r.value = !1, o();
    }, s = () => {
    };
    return (m, d) => (u(), b("div", null, [
      V(v("input", {
        "onUpdate:modelValue": d[0] || (d[0] = (_) => mi(t) ? t.value = _ : t = _),
        type: "text",
        class: "form-control",
        onBlur: f,
        onChange: s,
        onClick: c,
        onMouseleave: o
      }, null, 544), [
        [Y, w(r) || w(n)],
        [Ze, w(t)]
      ]),
      V(v("div", {
        class: "editable-text",
        onMouseover: l
      }, I(w(t)), 545), [
        [Y, !w(r) && w(i)]
      ])
    ]));
  }
}), qo = /* @__PURE__ */ $(Ko, [["__scopeId", "data-v-4d14d738"]]), Qo = /* @__PURE__ */ L({
  __name: "AlcHeader",
  props: {
    headerType: {},
    headerStyle: {},
    headerText: {}
  },
  setup(e) {
    return (a, t) => (u(), M(hi(a.headerType), {
      class: C(["title", a.headerStyle])
    }, {
      default: Me(() => [
        j(a.$slots, "default", {}, () => [
          le(I(a.headerText), 1)
        ], !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Zo = /* @__PURE__ */ $(Qo, [["__scopeId", "data-v-e948ae8e"]]), mt = {
  mobile: {
    title: "Mobile",
    pathD: "M241.7 175.7H172.8c-24 0-42.8 18.8-42.8 42.8V418.9c0 24 18.8 42.8 42.8 42.8h125c24 0 42.8-18.8 42.8-42.8V318.2c11.7 3.3 23.8 4.7 36 4.7c25.7 0 49.7-6.9 71.9-20.6c20.6-13.7 37.7-32.5 49.7-54.8c8.6-17.1 13.7-39.4 13.7-60v-8.6c-1.7-34.3-15.4-65.1-39.4-89.1s-54.8-37.7-89.1-39.4h-6.9c-20.6-1.7-41.1 3.4-60 13.7c-22.3 10.3-41.1 27.4-54.8 49.7c-11.9 19.3-18.6 39.8-20.2 61.7zm-8.9 155.9c3.4 3.4 6.9 5.1 12 5.1c1.7 0 3.4-1.7 3.4-1.7l58.2-19V418.9c0 5.1-3.4 8.6-8.6 8.6h-125c-5.1 0-8.6-3.4-8.6-8.6V218.5c0-5.1 5.1-8.6 8.6-8.6h71.1c2.2 10.6 5.5 21 9.5 30.8l-24 73.7c-3.4 5.1-1.7 12 3.4 17.1zM332.1 95.1c13.7-6.9 29.1-10.3 44.5-10.3h5.1c25.7 1.7 49.7 12 66.8 29.1s27.4 41.1 29.1 65.1v6.9c0 15.4-3.4 30.8-10.3 44.5c-8.6 17.1-22.3 30.8-37.7 41.1s-34.3 15.4-53.1 15.4c-15.4 0-30.8-3.4-44.5-10.3c-5.1-3.4-8.6-3.4-13.7-1.7l-46.2 15.4 15.4-46.2c0-5.1 0-10.3-1.7-13.7c-6.9-13.7-10.3-29.1-10.3-44.5c0-18.8 5.1-37.7 15.4-53.1c10.3-17.1 24-29.1 41.1-37.7z"
  },
  survey: {
    title: "Survey",
    pathD: "M544 396.5c0 11.3-9.2 20.5-20.5 20.5l-267.1 0c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5H523.5c11.3 0 20.5 9.2 20.5 20.5zm0-139.8c0 11.3-9.2 20.5-20.5 20.5l-237.7 0c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5l237.7 0c11.3 0 20.5 9.2 20.5 20.5zM154.3 312.3c-5.5 .2-10.9-1.8-15-5.6l-37-35.1c-8.2-7.8-8.5-20.7-.7-28.9s20.7-8.5 28.9-.7l21.6 20.6 48.2-54.1c7.5-8.4 20.4-9.2 28.9-1.7s9.2 20.4 1.7 28.9l-62.2 69.9c-3.7 4.1-8.9 6.6-14.4 6.8zm0-139.8c-5.5 .2-10.9-1.8-15-5.6l-37-35.1c-8.2-7.8-8.5-20.7-.7-28.9s20.7-8.5 28.9-.7l21.6 20.6 48.2-54.1c7.5-8.4 20.4-9.2 28.9-1.7s9.2 20.4 1.7 28.9l-62.2 69.9c-3.7 4.1-8.9 6.6-14.4 6.8zM544 117c0 11.3-9.2 20.5-20.5 20.5l-237.7 0c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5l237.7 0c11.3 0 20.5 9.2 20.5 20.5zM124.7 396.5a27.7 27.7 0 1 1 55.4 0 27.7 27.7 0 1 1 -55.4 0z"
  },
  web: {
    title: "Web",
    pathD: "M158 106.9c-5.1 0-9.9 2-13.5 5.6s-5.6 8.4-5.6 13.5V328.5c0 5.1 2 9.9 5.6 13.5s8.4 5.6 13.5 5.6h20.3c11.8 0 21.5 9.6 21.5 21.5s-9.6 21.5-21.5 21.5H158c-16.4 0-32.2-6.5-43.8-18.2S96 344.9 96 328.5V126c0-16.4 6.5-32.2 18.1-43.8S141.5 64 158 64H482c16.4 0 32.2 6.5 43.8 18.1S544 109.5 544 126V328.5c0 16.4-6.5 32.2-18.1 43.8s-27.4 18.2-43.8 18.2H461.8c-11.8 0-21.5-9.6-21.5-21.5s9.6-21.5 21.5-21.5H482c5.1 0 9.9-2 13.5-5.6s5.6-8.4 5.6-13.5V126c0-5.1-2-9.9-5.6-13.5s-8.4-5.6-13.5-5.6H158zm26.6 84.9c6.1-6.1 15.4-8 23.4-4.6L448.5 287.4c8.2 3.4 13.5 11.6 13.2 20.5s-6.1 16.7-14.5 19.6L375.1 352l66.6 66.6c8.4 8.4 8.4 22 0 30.3s-22 8.4-30.3 0l-66.6-66.6-24.5 72.1c-2.9 8.5-10.7 14.2-19.6 14.5s-17.1-5-20.5-13.2L179.9 215.2c-3.3-8-1.5-17.3 4.6-23.4zm55 55l58.3 140 17.3-50.9c2.1-6.3 7.1-11.3 13.4-13.4l50.9-17.3-140-58.3z"
  },
  workflow: {
    title: "Workflow",
    pathD: "M320.9 32c-40 0-72.5 32.4-72.5 72.5c0 18.6 7 35.5 18.5 48.3L166.2 326c-3.5-.5-7-.8-10.7-.8c-40 0-72.5 32.4-72.5 72.5s32.4 72.4 72.5 72.4s72.4-32.4 72.4-72.4c0-20.1-8.2-38.2-21.3-51.4l99.3-171.1c4.8 1 9.8 1.5 14.9 1.5c4.9 0 9.7-.5 14.4-1.4l99.5 171.3c-13 13.1-21 31.1-21 51c0 40 32.4 72.4 72.5 72.4s72.4-32.4 72.4-72.4s-32.3-72.5-72.4-72.5c-3.8 0-7.6 .3-11.2 .9l-100.5-173c11.7-12.9 18.8-29.9 18.8-48.6c0-39.9-32.3-72.5-72.4-72.5zm0 51a23.1 23.1 0 1 1 0 46.1 23.1 23.1 0 1 1 0-46.1zM486.1 376.2a23.1 23.1 0 1 1 0 46.1 23.1 23.1 0 1 1 0-46.1zm-330.6 0a23.1 23.1 0 1 1 0 46.1 23.1 23.1 0 1 1 0-46.1z"
  },
  clone: {
    title: "Clone",
    pathD: "M152 438H348c7.7 0 14-6.3 14-14V368h42v56c0 30.9-25.1 56-56 56H152c-30.9 0-56-25.1-56-56V228c0-30.9 25.1-56 56-56h56v42H152c-7.7 0-14 6.3-14 14V424c0 7.7 6.3 14 14 14zm140-98c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56H488c30.9 0 56 25.1 56 56V284c0 30.9-25.1 56-56 56H292zM488.7 70.9H294.7c-10 0-18.2 8.1-18.2 18.2V283c0 10 8.1 18.2 18.2 18.2H488.7c10 0 18.2-8.1 18.2-18.2V89c0-10-8.1-18.2-18.2-18.2z"
  },
  griplarge: {
    title: "Grip Large",
    pathD: "M104 160h72v72H104V160zm120 0h72v72H224V160zm120 0h72v72H344V160zm120 0h72v72H464V160zM104 280h72v72H104V280zm120 0h72v72H224V280zm120 0h72v72H344V280zm120 0h72v72H464V280z"
  },
  gripsmall: {
    title: "Grip Small",
    pathD: "M224 160h72v72H224V160zm120 0h72v72H344V160zM224 280h72v72H224V280zm120 0h72v72H344V280z"
  },
  star: {
    title: "Star",
    pathD: "M336.7 67.4c-3.1-6.5-9.6-10.5-16.8-10.5s-13.6 4-16.8 10.5L249.8 177.3 130.6 194.9c-7 1.1-12.8 6-15 12.7s-.5 14.1 4.6 19.1l86.4 85.6-20.4 121c-1.2 7 1.8 14.1 7.5 18.3s13.4 4.7 19.7 1.3L319.9 396l106.6 56.9c6.2 3.3 13.9 2.9 19.7-1.3s8.6-11.3 7.5-18.3l-20.4-121 86.4-85.7c5-5 6.8-12.3 4.6-19.1s-8-11.7-15-12.7L390.1 177.3 336.7 67.4z"
  }
}, Jo = { class: "alc-icon-svg" }, xo = { class: "alc-icon-svg__icon" }, el = ["height", "title"], al = ["d"], tl = /* @__PURE__ */ L({
  __name: "AlcIconSvg",
  props: {
    icon: { default: pt.WORKFLOW },
    iconBackgroundColor: { default: H.GOLD },
    iconColor: { default: H.WHITE },
    iconShape: { default: ce.ROUND },
    iconSize: { default: He.SMALL }
  },
  setup(e) {
    te((l) => ({
      "3012fed6": t.value,
      b7a1fee0: n.value,
      d053c24e: o.value,
      "5ae6cf88": r.value
    }));
    const a = e, t = P(() => `${+a.iconSize * 1.5}px`), n = P(() => `var(${a.iconBackgroundColor})`), r = P(() => `var(${a.iconColor})`), i = P(() => `${a.iconSize}px`), o = P(() => `${a.iconShape === ce.SQUARE ? "4px" : "50%"}`);
    return (l, c) => (u(), b("div", Jo, [
      v("div", xo, [
        (u(), b("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          height: i.value,
          title: w(mt)[l.icon].title,
          viewBox: "0 0 640 512"
        }, [
          v("path", {
            d: w(mt)[l.icon].pathD
          }, null, 8, al)
        ], 8, el))
      ])
    ]));
  }
}), nl = /* @__PURE__ */ $(tl, [["__scopeId", "data-v-1b0efe2e"]]), il = (e) => (gt("data-v-8c7bc04d"), e = e(), bt(), e), rl = { class: "alc-indeterminate-loader" }, ol = /* @__PURE__ */ il(() => /* @__PURE__ */ v("div", { class: "alc-indeterminate-loader__bar" }, null, -1)), ll = [
  ol
], cl = /* @__PURE__ */ L({
  __name: "AlcIndeterminateLoader",
  props: {
    trackColor: { default: "--alc-base-200" },
    barColor: { default: "--alc-aqua-700" },
    barWidthPercent: { default: "50%" },
    duration: { default: "3000ms" }
  },
  setup(e) {
    te((r) => ({
      cc33e866: t.value,
      "0979f3ae": r.barWidthPercent,
      "1b399176": n.value,
      "527c6a9d": r.duration
    }));
    const a = e, t = P(() => `var(${a.trackColor})`), n = P(() => `var(${a.barColor})`);
    return (r, i) => (u(), b("div", rl, ll));
  }
}), sl = /* @__PURE__ */ $(cl, [["__scopeId", "data-v-8c7bc04d"]]), fl = { class: "alc-input" }, ul = ["id", "name", "placeholder", "disabled", "readonly"], dl = { class: "alc-input__icons-right" }, ml = /* @__PURE__ */ L({
  __name: "AlcInput",
  props: {
    bordered: { type: Boolean, default: !0 },
    classes: { default: void 0 },
    defaultValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    focusBehavior: { default: "none" },
    hasError: { type: Boolean, default: !1 },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    iconRightClickHandler: { type: Function, default: void 0 },
    id: { default: void 0 },
    placeholder: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    resetable: { type: Boolean, default: !0 },
    name: {}
  },
  emits: ["input-changed", "input-reset"],
  setup(e, { emit: a }) {
    te((m) => ({
      "19d02464": o.value,
      "9376618a": l.value
    }));
    const t = e, n = a, r = S(t.defaultValue), i = P(() => {
      const m = ["alc-input__input"];
      return t.bordered ? (m.push({ "alc-input__input--bordered": t.bordered }), m.push({ "alc-input__input--error": t.hasError }), m.push({ "alc-input__input--bordered-error": t.hasError })) : (m.push({ "alc-input__input--unbordered": !0 }), m.push({ "alc-input__input--error": t.hasError })), t.classes && m.push(t.classes), m;
    }), o = P(() => t.iconLeft ? "32px" : t.bordered ? "8px" : "0"), l = P(() => t.resetable && t.iconRight ? "54px" : t.resetable || t.iconRight ? "32px" : t.bordered ? "8px" : "0"), c = () => {
      r.value = "", n("input-reset"), n("input-changed", "");
    }, f = (m) => {
      n("input-changed", m.target.value);
    }, s = (m) => {
      t.focusBehavior === "start" ? m.target.setSelectionRange(0, 0) : t.focusBehavior === "select" && m.target.select();
    };
    return Z(
      () => t.defaultValue,
      (m) => {
        r.value = m;
      }
    ), (m, d) => {
      const _ = K("FontAwesomeIcon");
      return u(), b("div", fl, [
        V(v("input", {
          id: t.id,
          name: t.name ?? "",
          "onUpdate:modelValue": d[0] || (d[0] = (p) => r.value = p),
          class: C([i.value]),
          placeholder: t.placeholder,
          disabled: t.disabled,
          readonly: t.readonly,
          onInput: f,
          onFocus: s
        }, null, 42, ul), [
          [Ze, r.value]
        ]),
        m.iconLeft ? (u(), M(_, {
          key: 0,
          class: "alc-input__icon-left",
          icon: t.iconLeft
        }, null, 8, ["icon"])) : A("", !0),
        v("div", dl, [
          V(T(_, {
            class: "alc-input__icon-clickable",
            icon: w(R).Close,
            title: "Reset",
            onClick: c
          }, null, 8, ["icon"]), [
            [Y, t.resetable]
          ]),
          m.iconRight ? (u(), M(_, {
            key: 0,
            icon: t.iconRight,
            class: C({ "alc-input__icon-clickable": t.iconRightClickHandler }),
            onClick: m.iconRightClickHandler
          }, null, 8, ["icon", "class", "onClick"])) : A("", !0)
        ])
      ]);
    };
  }
}), hl = /* @__PURE__ */ $(ml, [["__scopeId", "data-v-a035ebdf"]]), vl = ["aria-label", "aria-selected", "aria-disabled", "tabindex"], gl = { class: "alc-list-item__list-item-text" }, bl = { class: "alc-list-item__list-item-check" }, xt = /* @__PURE__ */ L({
  __name: "AlcListItem",
  props: {
    item: {}
  },
  emits: ["on-item-clicked"],
  setup(e, { emit: a }) {
    te((s) => ({
      da58bdbe: o.value
    }));
    const t = e, n = a, r = S(!1), i = S(!1), o = P(() => `${16 * (t.item.level ?? 0)}px`), l = (s) => {
      !t.item.disabled && (s.code === "Space" || s.code === "Enter") && n("on-item-clicked", t.item.value);
    }, c = () => {
      !t.item.disabled && !t.item.header && n("on-item-clicked", t.item.value);
    }, f = (s) => {
      s.target.focus();
    };
    return Z(
      () => t.item.selected,
      () => {
        r.value = t.item.selected ?? !1;
      },
      { immediate: !0 }
    ), Z(
      () => t.item.disabled,
      () => {
        i.value = t.item.disabled ?? !1;
      },
      { immediate: !0 }
    ), (s, m) => {
      const d = K("FontAwesomeIcon");
      return u(), b("div", {
        class: C(["alc-list-item__list-item", { "alc-list-item__list-item--disabled": i.value, "alc-list-item__list-item--header": t.item.header }]),
        role: "option",
        "aria-label": t.item.label,
        "aria-selected": r.value,
        "aria-disabled": i.value,
        tabindex: i.value ? -1 : 43,
        onClick: c,
        onKeydown: l,
        onMouseover: f
      }, [
        v("div", gl, I(t.item.label), 1),
        v("div", bl, [
          r.value ? (u(), M(d, {
            key: 0,
            icon: w(R).Check
          }, null, 8, ["icon"])) : A("", !0)
        ])
      ], 42, vl);
    };
  }
}), pl = ["aria-label", "aria-labelledby", "aria-hidden"], Ea = /* @__PURE__ */ L({
  __name: "AlcList",
  props: {
    itemClickHandler: {},
    items: {},
    scrolling: { type: Boolean, default: !1 },
    showList: { type: Boolean },
    tabindex: { default: 1 }
  },
  setup(e) {
    const t = S(Object.keys(e.items)[0]);
    return (n, r) => V((u(), b("div", {
      class: C(["alc-list__list", { "alc-list__list--scrolling": n.scrolling }]),
      role: "listbox",
      "aria-label": t.value,
      "aria-labelledby": `${t.value}Label`,
      "aria-multiselectable": "true",
      "aria-hidden": n.showList
    }, [
      (u(!0), b(ye, null, _e(n.items[t.value], (i, o) => (u(), M(xt, {
        key: `alc-item-${t.value}-${o}`,
        item: i,
        tabindex: n.tabindex + o,
        onOnItemClicked: n.itemClickHandler
      }, null, 8, ["item", "tabindex", "onOnItemClicked"]))), 128))
    ], 10, pl)), [
      [Y, n.showList]
    ]);
  }
}), yl = {}, _l = (e) => (gt("data-v-dbe47bba"), e = e(), bt(), e), kl = /* @__PURE__ */ _l(() => /* @__PURE__ */ v("div", { class: "overlay" }, null, -1));
function wl(e, a) {
  return u(), M(Aa, { to: "body" }, [
    kl
  ]);
}
const en = /* @__PURE__ */ $(yl, [["render", wl], ["__scopeId", "data-v-dbe47bba"]]), Pl = ["title"], Cl = { class: "modal__icon" }, Al = { class: "modal__title" }, Nl = {
  key: 0,
  class: "modal__close"
}, Ml = {
  key: 1,
  class: "modal__tabs"
}, Ll = ["onClick"], Ol = {
  key: 2,
  class: "modal__body"
}, Sl = { class: "modal__footer-left" }, zl = {
  key: 0,
  class: "modal__footer-btns-left"
}, Dl = { class: "modal__footer-right" }, Tl = {
  key: 0,
  class: "modal__footer-btns-right"
}, Il = /* @__PURE__ */ L({
  __name: "AlcModal",
  props: {
    bodyPaddingOverride: { default: void 0 },
    buttonPosition: { default: "right" },
    closeActionName: { default: "Cancel" },
    cssClasses: { default: "" },
    headerSize: { default: "medium" },
    icon: { default: void 0 },
    iconBackgroundColor: { default: H.GOLD },
    iconColor: { default: H.WHITE },
    iconShape: { default: ce.ROUND },
    primaryActionDisabled: { type: Boolean, default: !1 },
    primaryActionName: { default: "Save" },
    showBody: { type: Boolean, default: !0 },
    showCloseAction: { type: Boolean, default: !0 },
    showCloseX: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showFooterBorder: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showModal: { type: Boolean, default: !1 },
    showPrimaryAction: { type: Boolean, default: !0 },
    showTitleBorder: { type: Boolean, default: !0 },
    size: { default: "large" },
    tabs: { default: void 0 },
    title: { default: void 0 },
    useOverlay: { type: Boolean, default: !0 }
  },
  emits: ["on-primary-action", "on-close", "on-tab-click"],
  setup(e, { emit: a }) {
    te((s) => ({
      "74cbae6a": i.value,
      db05b962: o.value,
      e6e256c6: l.value
    }));
    const t = e, n = S(!1), r = a, i = P(() => t.size === "small" ? "25vw" : t.size === "medium" ? "50vw" : t.size === "large" ? "75vw" : t.size === "x-large" ? "90vw" : CSS.supports("width", t.size) ? t.size : "75vw"), o = P(() => t.headerSize === "medium" ? "24px" : "1.5em"), l = P(() => t.bodyPaddingOverride ? t.bodyPaddingOverride : "8px 16px"), c = () => {
      n.value = !1, r("on-close");
    }, f = () => {
      r("on-primary-action");
    };
    return (s, m) => {
      const d = K("FontAwesomeIcon");
      return u(), M(Aa, { to: "body" }, [
        s.useOverlay && s.showModal ? (u(), M(en, { key: 0 })) : A("", !0),
        V(v("div", {
          class: C(`modal-wrapper ${t.cssClasses}`),
          tabindex: "-1",
          role: "dialog",
          title: s.title
        }, [
          s.showHeader ? (u(), b("div", {
            key: 0,
            class: C({ modal__header: s.showHeader, "modal__header--bordered": s.showTitleBorder })
          }, [
            v("div", Cl, [
              j(s.$slots, "header-icon", {}, () => [
                s.icon ? (u(), M(x, {
                  key: 0,
                  icon: s.icon,
                  "icon-background-color": t.iconBackgroundColor,
                  "icon-color": t.iconColor,
                  "icon-shape": t.iconShape
                }, null, 8, ["icon", "icon-background-color", "icon-color", "icon-shape"])) : A("", !0)
              ], !0)
            ]),
            v("div", Al, I(s.title), 1),
            s.showCloseX ? (u(), b("div", Nl, [
              v("button", {
                type: "button",
                title: "Close",
                "aria-label": "close modal",
                onClick: c
              }, [
                T(d, {
                  icon: w(R).Close,
                  class: "modal__close-icon",
                  "background-color": w(H).INHERIT,
                  color: w(H).MEDIUMGRAY
                }, null, 8, ["icon", "background-color", "color"])
              ])
            ])) : A("", !0)
          ], 2)) : A("", !0),
          t.tabs ? (u(), b("div", Ml, [
            v("ul", null, [
              (u(!0), b(ye, null, _e(t.tabs, (_, p) => (u(), b("li", {
                key: p + _.replace(/[^a-zA-Z]/g, ""),
                class: C({ active: p === 0 }),
                onClick: (k) => r("on-tab-click", p)
              }, I(_), 11, Ll))), 128))
            ])
          ])) : A("", !0),
          s.showBody ? (u(), b("div", Ol, [
            j(s.$slots, "body", {}, void 0, !0)
          ])) : A("", !0),
          s.showFooter ? (u(), b("div", {
            key: 3,
            class: C(["modal__footer", { "modal__footer--bordered": t.showFooterBorder }])
          }, [
            v("div", Sl, [
              t.buttonPosition === "left" || t.buttonPosition === "full" ? (u(), b("div", zl, [
                s.showPrimaryAction && t.buttonPosition !== "full" ? (u(), M(he, {
                  key: 0,
                  size: w(re).SMALL,
                  disabled: s.primaryActionDisabled,
                  label: s.primaryActionName,
                  onAlcBtnClick: f
                }, null, 8, ["size", "disabled", "label"])) : A("", !0),
                s.showCloseAction ? (u(), M(he, {
                  key: 1,
                  variant: w(Ce).SECONDARY,
                  size: w(re).SMALL,
                  label: s.closeActionName,
                  stretch: t.buttonPosition === "full",
                  onAlcBtnClick: c
                }, null, 8, ["variant", "size", "label", "stretch"])) : A("", !0)
              ])) : j(s.$slots, "foot-left", { key: 1 }, void 0, !0)
            ]),
            v("div", Dl, [
              t.buttonPosition === "right" || t.buttonPosition === "full" ? (u(), b("div", Tl, [
                s.showCloseAction && t.buttonPosition !== "full" ? (u(), M(he, {
                  key: 0,
                  variant: w(Ce).SECONDARY,
                  size: w(re).SMALL,
                  label: s.closeActionName,
                  onAlcBtnClick: c
                }, null, 8, ["variant", "size", "label"])) : A("", !0),
                s.showPrimaryAction ? (u(), M(he, {
                  key: 1,
                  size: w(re).SMALL,
                  disabled: s.primaryActionDisabled,
                  label: s.primaryActionName,
                  stretch: t.buttonPosition === "full",
                  onAlcBtnClick: f
                }, null, 8, ["size", "disabled", "label", "stretch"])) : A("", !0)
              ])) : j(s.$slots, "footer-right", { key: 1 }, void 0, !0)
            ])
          ], 2)) : A("", !0)
        ], 10, Pl), [
          [Y, s.showModal]
        ])
      ]);
    };
  }
}), Rl = /* @__PURE__ */ $(Il, [["__scopeId", "data-v-be2fa4f8"]]);
function Hl(e) {
  return vi() ? (gi(e), !0) : !1;
}
function an(e) {
  return typeof e == "function" ? e() : w(e);
}
const tn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const $l = Object.prototype.toString, El = (e) => $l.call(e) === "[object Object]", We = () => {
}, Vl = /* @__PURE__ */ Bl();
function Bl() {
  var e, a;
  return tn && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((a = window == null ? void 0 : window.navigator) == null ? void 0 : a.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function De(e) {
  var a;
  const t = an(e);
  return (a = t == null ? void 0 : t.$el) != null ? a : t;
}
const nn = tn ? window : void 0;
function la(...e) {
  let a, t, n, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, n, r] = e, a = nn) : [a, t, n, r] = e, !a)
    return We;
  Array.isArray(t) || (t = [t]), Array.isArray(n) || (n = [n]);
  const i = [], o = () => {
    i.forEach((s) => s()), i.length = 0;
  }, l = (s, m, d, _) => (s.addEventListener(m, d, _), () => s.removeEventListener(m, d, _)), c = Z(
    () => [De(a), an(r)],
    ([s, m]) => {
      if (o(), !s)
        return;
      const d = El(m) ? { ...m } : m;
      i.push(
        ...t.flatMap((_) => n.map((p) => l(s, _, p, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    c(), o();
  };
  return Hl(f), f;
}
let ht = !1;
function Va(e, a, t = {}) {
  const { window: n = nn, ignore: r = [], capture: i = !0, detectIframe: o = !1 } = t;
  if (!n)
    return We;
  Vl && !ht && (ht = !0, Array.from(n.document.body.children).forEach((d) => d.addEventListener("click", We)), n.document.documentElement.addEventListener("click", We));
  let l = !0;
  const c = (d) => r.some((_) => {
    if (typeof _ == "string")
      return Array.from(n.document.querySelectorAll(_)).some((p) => p === d.target || d.composedPath().includes(p));
    {
      const p = De(_);
      return p && (d.target === p || d.composedPath().includes(p));
    }
  }), s = [
    la(n, "click", (d) => {
      const _ = De(e);
      if (!(!_ || _ === d.target || d.composedPath().includes(_))) {
        if (d.detail === 0 && (l = !c(d)), !l) {
          l = !0;
          return;
        }
        a(d);
      }
    }, { passive: !0, capture: i }),
    la(n, "pointerdown", (d) => {
      const _ = De(e);
      l = !c(d) && !!(_ && !d.composedPath().includes(_));
    }, { passive: !0 }),
    o && la(n, "blur", (d) => {
      setTimeout(() => {
        var _;
        const p = De(e);
        ((_ = n.document.activeElement) == null ? void 0 : _.tagName) === "IFRAME" && !(p != null && p.contains(n.document.activeElement)) && a(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => s.forEach((d) => d());
}
const jl = ["placeholder", "aria-label", "aria-labelledby", "tabindex"], Fl = { class: "alc-multiselect__list" }, Ul = /* @__PURE__ */ L({
  __name: "AlcMultiselect",
  props: {
    ariaLabel: { default: void 0 },
    ariaLabelledBy: { default: void 0 },
    error: { type: Boolean, default: !1 },
    items: {},
    placeholder: { default: "Select" },
    scrolling: { type: Boolean, default: !0 },
    selectedTextFormat: { default: "{0} selected" },
    tabIndex: { default: 42 }
  },
  emits: ["on-item-selected", "on-clear-selection"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, i = S(), o = S(), l = S(n.items), c = S(0);
    let f = "";
    const s = S(!1), m = (p) => {
      document.activeElement === (p == null ? void 0 : p.target) && (p.code === "Space" || (p == null || p.code)), s.value = !s.value;
    }, d = (p) => {
      p == null || p.stopPropagation(), f && l.value[f].forEach((k) => {
        k.selected = !1;
      }), c.value = 0, r("on-clear-selection");
    }, _ = (p) => {
      if (f) {
        const k = l.value[f].findIndex((N) => N.value === p);
        l.value[f][k].selected ? l.value[f][k].selected = !1 : l.value[f][k].selected = !0, r("on-item-selected", l.value[f]);
      }
    };
    return Va(o, () => {
      s.value = !1;
    }), Z(c, () => {
      i.value = c.value === 0 ? "" : n.selectedTextFormat.replace(/{(.*?)}/, c.value + "");
    }), Z(
      l.value,
      () => {
        f = Object.keys(l.value)[0], c.value = 0, l.value[f].forEach((p) => {
          c.value += p.selected ? 1 : 0;
        });
      },
      { immediate: !0 }
    ), a({
      clearSelections: d
    }), (p, k) => {
      const N = K("FontAwesomeIcon");
      return u(), b("div", {
        ref_key: "multiselector",
        ref: o,
        class: "alc-multiselect"
      }, [
        v("div", {
          class: "alc-multiselect__selector",
          onClick: k[1] || (k[1] = (h) => m(void 0))
        }, [
          V(v("input", {
            "onUpdate:modelValue": k[0] || (k[0] = (h) => i.value = h),
            type: "text",
            class: C(["alc-multiselect__input", { "alc-multiselect__input--error": p.error }]),
            readonly: "",
            placeholder: p.placeholder,
            role: "combobox",
            "aria-label": p.ariaLabel,
            "aria-labelledby": p.ariaLabelledBy,
            "aria-haspopup": "listbox",
            tabindex: p.tabIndex,
            onKeydown: m
          }, null, 42, jl), [
            [Ze, i.value]
          ]),
          V(T(N, {
            class: "alc-multiselect__input-icon alc-multiselect__input-icon--clear",
            icon: w(R).Close,
            title: "Clear",
            onClick: d
          }, null, 8, ["icon"]), [
            [Y, c.value > 0]
          ]),
          T(N, {
            class: "alc-multiselect__input-icon alc-multiselect__input-icon--open",
            icon: w(R).CaretDown,
            title: "Open"
          }, null, 8, ["icon"])
        ]),
        v("div", Fl, [
          T(Qe, null, {
            default: Me(() => [
              l.value ? (u(), M(Ea, {
                key: 0,
                items: l.value,
                "show-list": s.value,
                "item-click-handler": _,
                tabindex: p.tabIndex + 1,
                scrolling: p.scrolling
              }, null, 8, ["items", "show-list", "tabindex", "scrolling"])) : A("", !0)
            ]),
            _: 1
          })
        ])
      ], 512);
    };
  }
}), Gl = { class: "alc-overflow-menu__text" }, Wl = { class: "alc-overflow-menu__arrow" }, Yl = { class: "alc-overflow-menu__list" }, Xl = ["onClick"], Kl = { class: "alc-overflow-menu__list-item-text" }, ql = { class: "alc-overflow-menu__list-item-check" }, Ql = /* @__PURE__ */ L({
  __name: "AlcOverflowMenu",
  props: {
    itemList: {},
    selectedItemIndex: {}
  },
  emits: ["on-item-select"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = S(), i = S(!1), o = S(t.selectedItemIndex), l = () => {
      i.value = !i.value;
    }, c = (f) => {
      o.value = f, i.value = !1, n("on-item-select", t.itemList[f].value);
    };
    return Va(r, () => {
      i.value = !1;
    }), (f, s) => {
      const m = K("FontAwesomeIcon");
      return u(), b("div", {
        ref_key: "menuRef",
        ref: r,
        class: "alc-overflow-menu"
      }, [
        v("div", {
          class: C(["alc-overflow-menu__selector", { "alc-overflow-menu__selector--active": i.value }]),
          onClick: l
        }, [
          v("div", Gl, I(f.itemList[o.value].label), 1),
          v("div", Wl, [
            T(m, {
              icon: w(R).CaretDown
            }, null, 8, ["icon"])
          ])
        ], 2),
        V(v("div", Yl, [
          (u(!0), b(ye, null, _e(f.itemList, (d, _) => (u(), b("div", {
            key: `alc-overflow-item-${d.value}`,
            class: "alc-overflow-menu__list-item",
            onClick: (p) => c(_)
          }, [
            v("div", Kl, I(d.label), 1),
            v("div", ql, [
              o.value === _ ? (u(), M(m, {
                key: 0,
                icon: w(R).Check
              }, null, 8, ["icon"])) : A("", !0)
            ])
          ], 8, Xl))), 128))
        ], 512), [
          [Y, i.value]
        ])
      ], 512);
    };
  }
}), rn = /* @__PURE__ */ $(Ql, [["__scopeId", "data-v-d58fc2c4"]]), Zl = { class: "alc-pager" }, Jl = ["disabled"], xl = ["value"], ec = ["disabled"], ac = /* @__PURE__ */ L({
  __name: "AlcPager",
  props: {
    page: {},
    pageCount: {},
    itemsPerPage: {},
    loading: { type: Boolean }
  },
  emits: ["on-prev-click", "on-next-click", "on-page-input"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = S(t.page), i = S(), o = P(() => `${r.value} of ${t.pageCount}`);
    Z(
      () => t.page,
      () => {
        r.value = t.page;
      }
    );
    const l = () => {
      let s = +i.value.value;
      const m = r.value;
      r.value = 0, s >= t.pageCount && (s = t.pageCount), r.value = s, s === 0 && (r.value = m), n("on-page-input", r.value);
    }, c = (s) => {
      s.target.value = r.value.toString(), s.target.select();
    }, f = (s) => {
      (s.code === "Enter" || s.code === "Tab" || s.code === "NumpadEnter") && i.value.blur(), s.key !== "ArrowLeft" && s.key !== "ArrowRight" && s.key !== "Backspace" && s.key !== "Delete" && Number.isNaN(parseInt(s.key)) && s.preventDefault();
    };
    return (s, m) => {
      const d = K("FontAwesomeIcon");
      return u(), b("div", Zl, [
        v("button", {
          class: C(["alc-pager__button", { "alc-pager__button--disabled": s.loading }]),
          disabled: s.loading,
          onClick: m[0] || (m[0] = (_) => n("on-prev-click", -1))
        }, [
          T(d, {
            icon: w(R).AngleLeft
          }, null, 8, ["icon"])
        ], 10, Jl),
        v("input", {
          ref_key: "inputRef",
          ref: i,
          class: "alc-pager__input",
          type: "text",
          value: o.value,
          onFocus: c,
          onBlur: l,
          onKeydown: f
        }, null, 40, xl),
        v("button", {
          class: C(["alc-pager__button", { "alc-pager__button--disabled": s.loading }]),
          disabled: s.loading,
          onClick: m[1] || (m[1] = (_) => n("on-next-click", 1))
        }, [
          T(d, {
            icon: w(R).AngleRight
          }, null, 8, ["icon"])
        ], 10, ec)
      ]);
    };
  }
}), on = /* @__PURE__ */ $(ac, [["__scopeId", "data-v-a1f0a310"]]), tc = { class: "alc-paging" }, nc = { class: "alc-paging__left" }, ic = { class: "alc-paging__center" }, rc = { class: "alc-paging__right" }, oc = { class: "alc-paging__right-shim" }, lc = /* @__PURE__ */ L({
  __name: "AlcPaging",
  props: {
    page: {},
    pageCount: {},
    itemsPerPage: {},
    itemList: {},
    selectedItemIndex: {},
    prevClickHandler: { type: Function },
    nextClickHandler: { type: Function },
    inputPageHandler: { type: Function },
    perPageChangeHandler: { type: Function },
    loading: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (u(), b("div", tc, [
      v("div", nc, [
        j(a.$slots, "left")
      ]),
      v("div", ic, [
        T(on, {
          page: a.page,
          "page-count": a.pageCount,
          "items-per-page": a.itemsPerPage,
          loading: a.loading,
          onOnPrevClick: a.prevClickHandler,
          onOnNextClick: a.nextClickHandler,
          onOnPageInput: a.inputPageHandler
        }, null, 8, ["page", "page-count", "items-per-page", "loading", "onOnPrevClick", "onOnNextClick", "onOnPageInput"])
      ]),
      v("div", rc, [
        v("div", oc, [
          T(rn, {
            "item-list": a.itemList,
            "selected-item-index": a.selectedItemIndex,
            onOnItemSelect: a.perPageChangeHandler
          }, null, 8, ["item-list", "selected-item-index", "onOnItemSelect"])
        ])
      ])
    ]));
  }
}), cc = { class: "alc-panel" }, sc = { class: "alc-panel__header" }, fc = { class: "alc-panel__header-title" }, uc = { class: "alc-panel__header-tabs-container" }, dc = { class: "alc-panel__header-tabs" }, mc = { key: 0 }, hc = ["onClick"], vc = { class: "alc-panel__body" }, gc = { class: "alc-panel__content" }, bc = {
  key: 0,
  class: "alc-panel__footer"
}, pc = { class: "alc-panel__footer__left" }, yc = { class: "alc-panel__footer__right" }, _c = /* @__PURE__ */ L({
  __name: "AlcPanel",
  props: {
    title: { default: "Panel Title" },
    primaryButtonName: {},
    secondaryButtonName: {},
    showPanel: { type: Boolean, default: !0 },
    tabs: {},
    teleportToBody: { type: Boolean, default: !0 },
    disablePrimaryButton: { type: Boolean, default: !1 },
    showFooter: { type: Boolean, default: !0 }
  },
  emits: ["on-primary-btn-click", "on-secondary-btn-click", "on-tab-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, r = () => {
      n("on-primary-btn-click");
    }, i = () => {
      n("on-secondary-btn-click");
    };
    return (o, l) => (u(), M(Aa, {
      to: "body",
      disabled: !o.teleportToBody
    }, [
      T(Qe, { name: "slide-panel" }, {
        default: Me(() => [
          V(v("div", cc, [
            v("div", sc, [
              v("div", fc, I(t.title), 1),
              v("div", uc, [
                v("div", dc, [
                  t.tabs ? (u(), b("ul", mc, [
                    (u(!0), b(ye, null, _e(t.tabs, (c, f) => (u(), b("li", {
                      key: f + c.label.replace(/[^a-zA-Z]/g, ""),
                      class: C({ active: c.active }),
                      onClick: (s) => n("on-tab-click", f)
                    }, I(c.label), 11, hc))), 128))
                  ])) : A("", !0)
                ]),
                v("div", null, [
                  j(o.$slots, "header-help", {}, void 0, !0)
                ])
              ])
            ]),
            v("div", vc, [
              v("div", gc, [
                j(o.$slots, "default", {}, void 0, !0)
              ])
            ]),
            o.showFooter ? (u(), b("div", bc, [
              v("div", pc, [
                j(o.$slots, "footer-left", {}, void 0, !0)
              ]),
              v("div", yc, [
                t.secondaryButtonName ? (u(), M(he, {
                  key: 0,
                  variant: w(Ce).SECONDARY,
                  label: t.secondaryButtonName,
                  size: w(re).SMALL,
                  onAlcBtnClick: i
                }, null, 8, ["variant", "label", "size"])) : A("", !0),
                t.primaryButtonName ? (u(), M(he, {
                  key: 1,
                  label: t.primaryButtonName,
                  size: w(re).SMALL,
                  disabled: t.disablePrimaryButton,
                  onAlcBtnClick: r
                }, null, 8, ["label", "size", "disabled"])) : A("", !0)
              ])
            ])) : A("", !0)
          ], 512), [
            [Y, t.showPanel]
          ])
        ]),
        _: 3
      })
    ], 8, ["disabled"]));
  }
}), Zc = /* @__PURE__ */ $(_c, [["__scopeId", "data-v-b3ec787e"]]), kc = { class: "alc-section-nav" }, wc = ["data-cy", "onClick"], Pc = ["href"], Cc = /* @__PURE__ */ L({
  __name: "AlcSectionNav",
  props: {
    tabs: {}
  },
  setup(e) {
    const t = bi(e.tabs);
    function n(r) {
      t.forEach((i) => {
        i.id === r ? i.active = !0 : i.active = !1;
      });
    }
    return (r, i) => {
      const o = K("router-link");
      return u(), b("nav", kc, [
        v("ul", null, [
          (u(!0), b(ye, null, _e(t, (l) => (u(), b("li", {
            key: l.id,
            class: C([l.active ? "active" : "", "alc-section-tab"]),
            "data-cy": `alc-section-nav-${l.id}`,
            onClick: (c) => n(l.id)
          }, [
            l.routerLink ? (u(), M(o, {
              key: 0,
              to: l.routerLink
            }, {
              default: Me(() => [
                le(I(l.text), 1)
              ]),
              _: 2
            }, 1032, ["to"])) : A("", !0),
            l.href ? (u(), b("a", {
              key: 1,
              href: l.href
            }, I(l.text), 9, Pc)) : A("", !0)
          ], 10, wc))), 128))
        ])
      ]);
    };
  }
}), Ac = /* @__PURE__ */ $(Cc, [["__scopeId", "data-v-e1b0e139"]]), Nc = ["disabled", "placeholder", "aria-label", "aria-labelledby", "tabindex"], Mc = { class: "alc-singleselect__list" }, Lc = /* @__PURE__ */ L({
  __name: "AlcSingleSelect",
  props: {
    ariaLabel: { default: void 0 },
    ariaLabelledBy: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    items: {},
    placeholder: { default: "Select" },
    scrolling: { type: Boolean, default: !0 },
    showLabel: { type: Boolean, default: !1 },
    selectedTextFormat: { default: "{0} selected" },
    tabIndex: { default: 42 }
  },
  emits: ["on-item-selected", "on-clear-selection"],
  setup(e, { expose: a, emit: t }) {
    const n = e, r = t, i = S(), o = S(n.items), l = S(!1);
    let c = "";
    const f = S(!1), s = (k) => {
      p() || (document.activeElement === (k == null ? void 0 : k.target) && (k.code === "Space" || (k == null || k.code)), f.value = !f.value);
    }, m = (k) => {
      p() || (k == null || k.stopPropagation(), c && o.value[c].forEach((N) => {
        N.selected = !1;
      }), i.value = "", l.value = !1, r("on-clear-selection"));
    }, d = (k) => {
      if (!p() && c) {
        o.value[c].forEach((y) => {
          y.selected = !1;
        });
        const N = o.value[c].findIndex((y) => y.value === k), h = o.value[c][N];
        h.selected = !h.selected, h.selected && (_(h), r("on-item-selected", h));
      }
    };
    pi(() => {
      if (c) {
        const k = o.value[c].find((N) => N.selected);
        k && _(k);
      }
    });
    const _ = (k) => {
      i.value = n.selectedTextFormat.replace(
        /{(.*?)}/,
        n.showLabel ? k.label : k.value + ""
      );
    }, p = () => n.disabled;
    return Va(i, () => {
      f.value = !1;
    }), Z(l, () => {
      l.value && (f.value = !1);
    }), Z(
      o.value,
      () => {
        c = Object.keys(o.value)[0], l.value = !1, o.value[c].forEach((k) => {
          l.value = k.selected ? !0 : l.value;
        });
      },
      { immediate: !0 }
    ), a({
      clearSelections: m
    }), (k, N) => {
      const h = K("FontAwesomeIcon");
      return u(), b("div", {
        class: C(["alc-singleselect", { "alc-singleselect__disabled": k.disabled }])
      }, [
        v("div", {
          class: C({ "alc-singleselect__selector": !0, "alc-singleselect__selector__expand": f.value }),
          onClick: N[1] || (N[1] = (y) => s(void 0))
        }, [
          V(v("input", {
            "onUpdate:modelValue": N[0] || (N[0] = (y) => i.value = y),
            type: "text",
            class: C(["alc-singleselect__input", { "alc-singleselect__input--error": k.error }]),
            readonly: "",
            disabled: k.disabled,
            placeholder: k.placeholder,
            role: "dropdown",
            "aria-label": k.ariaLabel,
            "aria-labelledby": k.ariaLabelledBy,
            "aria-haspopup": "listbox",
            tabindex: k.tabIndex,
            onKeydown: s
          }, null, 42, Nc), [
            [Ze, i.value]
          ]),
          V(T(h, {
            class: "alc-singleselect__input-icon alc-singleselect__input-icon--clear",
            icon: w(R).Close,
            title: "Clear",
            onClick: m
          }, null, 8, ["icon"]), [
            [Y, l.value]
          ]),
          T(h, {
            class: "alc-singleselect__input-icon alc-singleselect__input-icon--open",
            icon: w(R).CaretDown,
            title: "Open"
          }, null, 8, ["icon"])
        ], 2),
        v("div", Mc, [
          T(Qe, null, {
            default: Me(() => [
              o.value ? (u(), M(Ea, {
                key: 0,
                items: o.value,
                "show-list": f.value,
                "item-click-handler": d,
                tabindex: k.tabIndex + 1,
                scrolling: k.scrolling
              }, null, 8, ["items", "show-list", "tabindex", "scrolling"])) : A("", !0)
            ]),
            _: 1
          })
        ])
      ], 2);
    };
  }
}), Oc = { class: "tile-base__content" }, Sc = { class: "tile-base__icons" }, zc = ["src"], Dc = { class: "tile-base__top" }, Tc = { class: "tile-base__title-container" }, Ic = {
  key: 2,
  class: "tile-base__title"
}, Rc = {
  key: 0,
  class: "tile-base__description-text"
}, Hc = ["target", "href"], $c = {
  key: 2,
  class: "tile-base__description-text"
}, Ec = ["href"], ln = /* @__PURE__ */ L({
  __name: "AlcTileBase",
  props: {
    title: {},
    description: {},
    link: { default: void 0 },
    linkText: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    image: { default: void 0 },
    enableSelect: { type: Boolean, default: !0 },
    clickable: { type: Boolean, default: !0 },
    newTab: { type: Boolean }
  },
  emits: ["on-tile-base-click"],
  setup(e, { emit: a }) {
    const t = a, n = e, r = P(() => ({
      "tile-base--selected": n.selected === !0 && !n.loading && !n.error,
      "tile-base--error": n.error === !0,
      "tile-base--loading": n.loading === !0,
      "tile-base--disable-click": n.clickable === !1
    }));
    function i(o) {
      n.enableSelect && !n.error && n.link && o.preventDefault(), t("on-tile-base-click");
    }
    return (o, l) => {
      const c = K("FontAwesomeIcon");
      return u(), b("div", {
        class: C(["tile-base", r.value]),
        onClick: i
      }, [
        v("div", Oc, [
          V(v("div", Sc, [
            o.loading ? (u(), M(c, {
              key: 0,
              class: C(r.value["tile-base--loading"] ? "tile-base--loading" : "")
            }, null, 8, ["class"])) : o.image && !o.error && !o.loading ? (u(), b("img", {
              key: 1,
              src: o.image,
              class: "tile-base__icon-url"
            }, null, 8, zc)) : o.icon && !o.error && !o.loading && !o.image ? (u(), M(x, {
              key: 2,
              class: "tile-base__icon",
              icon: o.icon.iconKey,
              "icon-background-color": o.icon.iconBackgroundColor,
              "icon-color": o.icon.iconColor,
              "icon-shape": o.icon.iconShape,
              "icon-size": o.icon.iconSize,
              "icon-clickable": o.icon.iconClickable
            }, null, 8, ["icon", "icon-background-color", "icon-color", "icon-shape", "icon-size", "icon-clickable"])) : !o.loading && o.error && o.icon ? (u(), M(x, {
              key: 3,
              class: C(["tile-base__icon", r.value["tile-base--error"] ? "tile-base--error" : ""]),
              icon: o.icon.iconKey,
              "icon-background-color": o.icon.iconBackgroundColor,
              "icon-color": o.icon.iconColor,
              "icon-shape": o.icon.iconShape,
              "icon-size": o.icon.iconSize,
              "icon-clickable": o.icon.iconClickable
            }, null, 8, ["class", "icon", "icon-background-color", "icon-color", "icon-shape", "icon-size", "icon-clickable"])) : A("", !0)
          ], 512), [
            [Y, o.icon || o.image]
          ]),
          v("div", {
            class: C([r.value["tile-base--loading"] ? "tile-base--loading" : "", "tile-base__body"])
          }, [
            v("div", Dc, [
              v("div", Tc, [
                o.loading ? (u(), b("div", {
                  key: 0,
                  class: C(["tile-base__title", r.value["tile-base--loading"] ? "tile-base--loading" : ""])
                }, null, 2)) : o.error && o.title ? (u(), b("div", {
                  key: 1,
                  class: C(["tile-base__title", r.value])
                }, I(o.title), 3)) : (u(), b("div", Ic, I(o.title), 1))
              ])
            ]),
            v("div", {
              class: C([r.value["tile-base--loading"] ? "tile-base--loading" : "", "tile-base__description"])
            }, [
              o.loading ? (u(), b("div", Rc)) : o.error && o.description ? (u(), b("div", {
                key: 1,
                class: C([r.value["tile-base--error"] ? "tile-base--error" : "", "tile-base__description-text"])
              }, [
                le(I(o.description) + " ", 1),
                o.link ? (u(), b("a", {
                  key: 0,
                  class: C([r.value, "tile-base__description-link"]),
                  target: o.newTab ? "_blank" : "_self",
                  href: o.link
                }, I(o.linkText ? o.linkText : "Retry?"), 11, Hc)) : A("", !0)
              ], 2)) : (u(), b("div", $c, [
                le(I(o.description) + " ", 1),
                o.link ? (u(), b("a", {
                  key: 0,
                  class: C([r.value, "tile-base__description-link"]),
                  target: "_blank",
                  href: o.link
                }, I(o.linkText), 11, Ec)) : A("", !0)
              ]))
            ], 2)
          ], 2)
        ])
      ], 2);
    };
  }
}), Vc = { class: "tile-group__container" }, Bc = /* @__PURE__ */ L({
  __name: "AlcTileGroupBase",
  props: {
    tiles: {},
    selected: {}
  },
  emits: ["on-tile-base-group-selection"],
  setup(e) {
    return (a, t) => (u(), b("div", Vc, [
      (u(!0), b(ye, null, _e(a.tiles, (n) => (u(), M(ln, {
        key: n.id,
        title: n.type_label,
        description: n.type_description,
        link: n.link,
        "link-text": n.link_text,
        icon: n.icon,
        image: n.image,
        loading: n.loading,
        error: n.error,
        selected: n.id === a.selected,
        "enable-select": n.enableSelect,
        clickable: n.clickable,
        "new-tab": n.newTab,
        onOnTileBaseClick: (r) => a.$emit("on-tile-base-group-selection", n.id)
      }, null, 8, ["title", "description", "link", "link-text", "icon", "image", "loading", "error", "selected", "enable-select", "clickable", "new-tab", "onOnTileBaseClick"]))), 128))
    ]));
  }
}), jc = /* @__PURE__ */ L({
  __name: "AlcToolboxIcon",
  props: {
    backgroundColor: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    icon: {}
  },
  emits: ["on-toolbox-btn-click"],
  setup(e, { emit: a }) {
    te((o) => ({
      "61ed20f7": i.value
    }));
    const t = e, n = a, r = () => {
      t.disabled || n("on-toolbox-btn-click");
    }, i = P(() => t.backgroundColor || "var(--alc-white)");
    return (o, l) => (u(), b("div", {
      class: C(["alc-toolbox-icon", { "alc-toolbox-icon--disabled": t.disabled }]),
      onClick: r
    }, [
      T(w(Ca), {
        icon: t.icon
      }, null, 8, ["icon"])
    ], 2));
  }
}), Fc = /* @__PURE__ */ $(jc, [["__scopeId", "data-v-24c47d76"]]), Uc = ["data-tooltip-text"], Oe = 4, Gc = /* @__PURE__ */ L({
  __name: "AlcTooltip",
  props: {
    tooltipText: { default: "This is a a tooltip!" },
    position: { default: "top" },
    multiline: { type: Boolean, default: !1 }
  },
  setup(e) {
    te((f) => ({
      f999c1c2: r.value,
      "4c4a4034": t.value,
      "617d5396": n.value,
      "626c27d2": i.value,
      "5891f2ac": o.value,
      "557be3e9": l.value,
      "34b085c0": c.value
    }));
    const a = e, t = P(() => a.position === "top" ? "0" : a.position === "right" ? "50%" : a.position === "bottom" ? `calc(100% + ${Oe}px)` : a.position === "left" ? "50%" : "0"), n = P(() => a.position === "top" ? "50%" : a.position === "right" ? `calc(100% + ${Oe}px)` : a.position === "bottom" ? "50%" : a.position === "left" ? `-${Oe}px` : "50%"), r = P(() => a.position === "top" ? `-50% calc(-100% - ${Oe}px)` : a.position === "right" ? "0 -50%" : a.position === "bottom" ? "-50%" : a.position === "left" ? "-100% -50%" : `-50% calc(-100% - ${Oe}px)`), i = P(() => a.multiline ? "150px" : "auto"), o = P(() => a.multiline ? "normal" : "nowrap"), l = P(() => a.position === "top" ? "var(--alc-gray-700) transparent transparent transparent" : a.position === "right" ? "transparent var(--alc-gray-700) transparent transparent" : a.position === "bottom" ? "transparent transparent var(--alc-gray-700) transparent" : a.position === "left" ? "transparent transparent transparent var(--alc-gray-700)" : "var(--alc-gray-700) transparent transparent transparent"), c = P(() => a.position === "top" ? "0 0 0 50%" : a.position === "right" ? "50% 0 0 100%" : a.position === "bottom" ? "100% 0 0 50%" : a.position === "left" ? "50% 0 0 0" : "0 0 0 50%");
    return (f, s) => (u(), b("div", {
      class: "alc-tooltip alc-tooltip--multiline",
      "data-tooltip-text": f.tooltipText
    }, [
      j(f.$slots, "default", {}, () => [
        le("Hover Me")
      ], !0)
    ], 8, Uc));
  }
}), Wc = /* @__PURE__ */ $(Gc, [["__scopeId", "data-v-4021a903"]]), Yc = {}, Xc = { class: "vertical-divider" };
function Kc(e, a) {
  return u(), b("div", Xc);
}
const qc = /* @__PURE__ */ $(Yc, [["render", Kc], ["__scopeId", "data-v-79ab0d3d"]]);
var cn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "angle-down", n = 448, r = 512, i = [8964], o = "f107", l = "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faAngleDown = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(cn);
var sn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "angle-left", n = 320, r = 512, i = [8249], o = "f104", l = "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faAngleLeft = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(sn);
var fn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "angle-right", n = 320, r = 512, i = [8250], o = "f105", l = "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faAngleRight = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(fn);
var un = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "angle-up", n = 448, r = 512, i = [8963], o = "f106", l = "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faAngleUp = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(un);
var dn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "arrow-down", n = 384, r = 512, i = [8595], o = "f063", l = "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faArrowDown = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(dn);
var mn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "arrow-left", n = 448, r = 512, i = [8592], o = "f060", l = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faArrowLeft = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(mn);
var hn = {}, vn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "arrows-up-down", n = 320, r = 512, i = ["arrows-v"], o = "f07d", l = "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faArrowsUpDown = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(vn);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = vn;
  e.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, e.faArrowsV = e.definition, e.prefix = a.prefix, e.iconName = a.iconName, e.width = a.width, e.height = a.height, e.ligatures = a.aliases, e.unicode = a.unicode, e.svgPathData = a.svgPathData, e.aliases = a.aliases;
})(hn);
var gn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "bookmark", n = 384, r = 512, i = [128278, 61591], o = "f02e", l = "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faBookmark = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(gn);
var bn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "caret-down", n = 320, r = 512, i = [], o = "f0d7", l = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCaretDown = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(bn);
var pn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "caret-left", n = 256, r = 512, i = [], o = "f0d9", l = "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCaretLeft = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(pn);
var yn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "caret-right", n = 256, r = 512, i = [], o = "f0da", l = "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCaretRight = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(yn);
var _n = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "caret-up", n = 320, r = 512, i = [], o = "f0d8", l = "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCaretUp = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(_n);
var kn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "chart-column", n = 512, r = 512, i = [], o = "e0e3", l = "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faChartColumn = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(kn);
var wn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "check", n = 448, r = 512, i = [10003, 10004], o = "f00c", l = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCheck = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(wn);
var Pn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "circle", n = 512, r = 512, i = [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], o = "f111", l = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircle = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Pn);
var Cn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "circle-check", n = 512, r = 512, i = [61533, "check-circle"], o = "f058", l = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleCheck = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Cn);
var An = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "circle-check", n = 512, r = 512, i = [61533, "check-circle"], o = "f058", l = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleCheck = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(An);
var Nn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "circle-exclamation", n = 512, r = 512, i = ["exclamation-circle"], o = "f06a", l = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleExclamation = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Nn);
var Mn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "circle-info", n = 512, r = 512, i = ["info-circle"], o = "f05a", l = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleInfo = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Mn);
var Ln = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "circle-info", n = 512, r = 512, i = ["info-circle"], o = "f05a", l = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleInfo = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Ln);
var On = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "circle-xmark", n = 512, r = 512, i = [61532, "times-circle", "xmark-circle"], o = "f057", l = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCircleXmark = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(On);
var Sn = {}, Ba = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "xmark", n = 384, r = 512, i = [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], o = "f00d", l = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faXmark = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Ba);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = Ba;
  e.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, e.faClose = e.definition, e.prefix = a.prefix, e.iconName = a.iconName, e.width = a.width, e.height = a.height, e.ligatures = a.aliases, e.unicode = a.unicode, e.svgPathData = a.svgPathData, e.aliases = a.aliases;
})(Sn);
var zn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "copy", n = 448, r = 512, i = [], o = "f0c5", l = "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCopy = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(zn);
var Dn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "download", n = 512, r = 512, i = [], o = "f019", l = "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faDownload = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Dn);
var Tn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "ellipsis-vertical", n = 128, r = 512, i = ["ellipsis-v"], o = "f142", l = "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faEllipsisVertical = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Tn);
var In = {}, Rn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "arrow-up-right-from-square", n = 512, r = 512, i = ["external-link"], o = "f08e", l = "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faArrowUpRightFromSquare = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Rn);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = Rn;
  e.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, e.faExternalLink = e.definition, e.prefix = a.prefix, e.iconName = a.iconName, e.width = a.width, e.height = a.height, e.ligatures = a.aliases, e.unicode = a.unicode, e.svgPathData = a.svgPathData, e.aliases = a.aliases;
})(In);
var Hn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "file", n = 384, r = 512, i = [128196, 128459, 61462], o = "f15b", l = "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faFile = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Hn);
var $n = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "gear", n = 512, r = 512, i = [9881, "cog"], o = "f013", l = "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faGear = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})($n);
var En = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "link", n = 640, r = 512, i = [128279, "chain"], o = "f0c1", l = "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faLink = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(En);
var Vn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "list-check", n = 512, r = 512, i = ["tasks"], o = "f0ae", l = "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faListCheck = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Vn);
var Bn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "lock", n = 448, r = 512, i = [128274], o = "f023", l = "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faLock = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Bn);
var jn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "lock-open", n = 576, r = 512, i = [], o = "f3c1", l = "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faLockOpen = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(jn);
var Fn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "magnifying-glass", n = 512, r = 512, i = [128269, "search"], o = "f002", l = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faMagnifyingGlass = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Fn);
var Un = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "outdent", n = 448, r = 512, i = ["dedent"], o = "f03b", l = "M0 64C0 50.7 10.7 40 24 40H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 88 0 77.3 0 64zM192 192c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24zm24 104H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 448c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM7 268.4C-.8 262-.8 250 7 243.6l94.8-78.1c10.4-8.6 26.2-1.2 26.2 12.4V334.1c0 13.5-15.7 20.9-26.2 12.4L7 268.4z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faOutdent = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Un);
var Gn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "pen", n = 512, r = 512, i = [128394], o = "f304", l = "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faPen = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Gn);
var Wn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "pen", n = 512, r = 512, i = [128394], o = "f304", l = "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faPen = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Wn);
var Yn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "pencil", n = 512, r = 512, i = [9999, 61504, "pencil-alt"], o = "f303", l = "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faPencil = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Yn);
var Xn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "person-running", n = 448, r = 512, i = [127939, "running"], o = "f70c", l = "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faPersonRunning = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Xn);
var Kn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "plus", n = 448, r = 512, i = [10133, 61543, "add"], o = "2b", l = "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faPlus = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Kn);
var qn = {}, Qn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "arrows-rotate", n = 512, r = 512, i = [128472, "refresh", "sync"], o = "f021", l = "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faArrowsRotate = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Qn);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = Qn;
  e.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, e.faRefresh = e.definition, e.prefix = a.prefix, e.iconName = a.iconName, e.width = a.width, e.height = a.height, e.ligatures = a.aliases, e.unicode = a.unicode, e.svgPathData = a.svgPathData, e.aliases = a.aliases;
})(qn);
var Zn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "rotate-left", n = 512, r = 512, i = ["rotate-back", "rotate-backward", "undo-alt"], o = "f2ea", l = "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faRotateLeft = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Zn);
var Jn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "rotate-right", n = 512, r = 512, i = ["redo-alt", "rotate-forward"], o = "f2f9", l = "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faRotateRight = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(Jn);
var xn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "spinner", n = 512, r = 512, i = [], o = "f110", l = "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faSpinner = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(xn);
var ei = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "spinner-third", n = 512, r = 512, i = [], o = "f3f4", l = "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faSpinnerThird = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ei);
var ai = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "square", n = 448, r = 512, i = [9632, 9723, 9724, 61590], o = "f0c8", l = "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faSquare = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ai);
var ti = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "table", n = 512, r = 512, i = [], o = "f0ce", l = "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTable = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ti);
var ni = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "table-columns", n = 512, r = 512, i = ["columns"], o = "f0db", l = "M48 416V160H232V432H64c-8.8 0-16-7.2-16-16zm232 16V160H464V416c0 8.8-7.2 16-16 16H280zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTableColumns = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ni);
var ii = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "table-list", n = 512, r = 512, i = ["th-list"], o = "f00b", l = "M192 80v88H464V96c0-8.8-7.2-16-16-16H192zm-48 0H64c-8.8 0-16 7.2-16 16v72h96V80zM48 216v80h96V216H48zm0 128v72c0 8.8 7.2 16 16 16h80V344H48zm144 88H448c8.8 0 16-7.2 16-16V344H192v88zM464 296V216H192v80H464zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTableList = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ii);
var ri = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = Ba;
  e.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, e.faTimes = e.definition, e.prefix = a.prefix, e.iconName = a.iconName, e.width = a.width, e.height = a.height, e.ligatures = a.aliases, e.unicode = a.unicode, e.svgPathData = a.svgPathData, e.aliases = a.aliases;
})(ri);
var oi = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "trash", n = 448, r = 512, i = [], o = "f1f8", l = "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTrash = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(oi);
var li = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "trash-can", n = 448, r = 512, i = [61460, "trash-alt"], o = "f2ed", l = "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTrashCan = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(li);
var ci = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "triangle-exclamation", n = 512, r = 512, i = [9888, "exclamation-triangle", "warning"], o = "f071", l = "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTriangleExclamation = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ci);
var si = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "triangle-exclamation", n = 512, r = 512, i = [9888, "exclamation-triangle", "warning"], o = "f071", l = "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faTriangleExclamation = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(si);
var fi = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "fas", t = "users", n = 640, r = 512, i = [], o = "f0c0", l = "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faUsers = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(fi);
var ui = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var a = "far", t = "calendar", n = 448, r = 512, i = [128197, 128198], o = "f133", l = "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z";
  e.definition = {
    prefix: a,
    iconName: t,
    icon: [
      n,
      r,
      i,
      o,
      l
    ]
  }, e.faCalendar = e.definition, e.prefix = a, e.iconName = t, e.width = n, e.height = r, e.ligatures = i, e.unicode = o, e.svgPathData = l, e.aliases = i;
})(ui);
co.add(
  cn.faAngleDown,
  sn.faAngleLeft,
  fn.faAngleRight,
  un.faAngleUp,
  dn.faArrowDown,
  mn.faArrowLeft,
  hn.faArrowsV,
  gn.faBookmark,
  bn.faCaretDown,
  pn.faCaretLeft,
  yn.faCaretRight,
  _n.faCaretUp,
  kn.faChartColumn,
  wn.faCheck,
  Pn.faCircle,
  Cn.faCircleCheck,
  An.faCircleCheck,
  Nn.faCircleExclamation,
  Mn.faCircleInfo,
  Ln.faCircleInfo,
  On.faCircleXmark,
  Sn.faClose,
  zn.faCopy,
  Dn.faDownload,
  Tn.faEllipsisVertical,
  In.faExternalLink,
  Hn.faFile,
  $n.faGear,
  En.faLink,
  Vn.faListCheck,
  Bn.faLock,
  jn.faLockOpen,
  Fn.faMagnifyingGlass,
  Un.faOutdent,
  Gn.faPen,
  Wn.faPen,
  Yn.faPencil,
  Xn.faPersonRunning,
  Kn.faPlus,
  qn.faRefresh,
  Zn.faRotateLeft,
  Jn.faRotateRight,
  xn.faSpinner,
  ei.faSpinnerThird,
  ai.faSquare,
  ti.faTable,
  ni.faTableColumns,
  ii.faTableList,
  ri.faTimes,
  oi.faTrash,
  li.faTrashCan,
  ci.faTriangleExclamation,
  si.faTriangleExclamation,
  fi.faUsers,
  ui.faCalendar
);
const Jc = {
  install: (e) => {
    e.component("AlcAlert", wi), e.component("AlcButton", he), e.component("AlcCardBase", Bo), e.component("AlcContextMenu", Xo), e.component("AlcEditableText", qo), e.component("AlcHeader", Zo), e.component("AlcIcon", x), e.component("AlcIconSvg", nl), e.component("AlcIndeterminateLoader", sl), e.component("AlcInput", hl), e.component("AlcList", Ea), e.component("AlcListItem", xt), e.component("AlcModal", Rl), e.component("AlcMultiselect", Ul), e.component("AlcOverflowMenu", rn), e.component("AlcOverlay", en), e.component("AlcPager", on), e.component("AlcPaging", lc), e.component("AlcSectionNav", Ac), e.component("AlcSingleSelect", Lc), e.component("AlcTileBase", ln), e.component("AlcTileGroupBase", Bc), e.component("AlcToolboxIcon", Fc), e.component("AlcTooltip", Wc), e.component("AlcVerticalDivider", qc);
  }
};
export {
  wi as AlcAlert,
  he as AlcButton,
  Bo as AlcCardBase,
  Xo as AlcContextMenu,
  qo as AlcEditableText,
  Zo as AlcHeader,
  x as AlcIcon,
  nl as AlcIconSvg,
  sl as AlcIndeterminateLoader,
  hl as AlcInput,
  Ea as AlcList,
  xt as AlcListItem,
  Rl as AlcModal,
  Ul as AlcMultiselect,
  rn as AlcOverflowMenu,
  en as AlcOverlay,
  on as AlcPager,
  lc as AlcPaging,
  Zc as AlcPanel,
  Ac as AlcSectionNav,
  Lc as AlcSingleSelect,
  ln as AlcTileBase,
  Bc as AlcTileGroupBase,
  Fc as AlcToolboxIcon,
  Wc as AlcTooltip,
  qc as AlcVerticalDivider,
  ke as AlertTypeEnum,
  re as ButtonSizeEnum,
  Ce as ButtonVariantEnum,
  pt as CustomIconEnum,
  R as FAIconEnum,
  Ca as FontAwesomeIcon,
  H as IconColorsEnum,
  ce as IconShapeEnum,
  He as IconSizeEnum,
  yi as SizeEnum,
  Jc as default
};
